<template>
  <div class="okr-monitoramento">
    <loader object="#df3e46" v-show="progress" color1="#0db9d3" color2="#fff01f" size="6" speed="2.4" bg="#C0C0C0" objectbg="#0d0c0d" opacity="50" name="circular"></loader>

    <div class="container-fluid">
      <ol class="breadcrumb-arrow">
        <li>
          <a href="/home"><i class="fa fa-home"></i></a>
          <a href="#">OKR — Monitoramento</a>
        </li>
      </ol>
    </div>

    <!-- BOTÃO FLUTUANTE -->
    <el-tooltip content="Novo Objetivo" placement="top">
      <button type="button" class="btn btn-primary fab-button shadow-lg" @click="novoOkr()">
        <i class="fas fa-plus"></i>
      </button>
    </el-tooltip>

    <div class="container-fluid mt-2">

      <!-- FILTROS -->
      <div class="card mb-3">
        <div class="card-header filtros-header py-2" @click="accordionFiltros = !accordionFiltros" style="cursor:pointer;">
          <strong><i class="fas fa-filter mr-2"></i>Filtros</strong>
          <i :class="accordionFiltros ? 'fas fa-chevron-up float-right' : 'fas fa-chevron-down float-right'"></i>
        </div>
        <div v-show="accordionFiltros" class="card-body p-2">
          <div class="row align-items-end mb-2">
            <div class="col-md-2" v-if="perfil === 'ADMIN' || perfil === 'DIRETOR'">
              <label class="mb-0 small text-muted font-weight-bold">Departamento</label>
              <select class="form-control form-control-sm" v-model="filtro.departamento" @change="changeDepartamento()">
                <option value="">Todos</option>
                <option v-for="d in listaDepartamentoFiltro" :key="d.iddepartamento" :value="d.iddepartamento">{{ d.sigla }}</option>
              </select>
            </div>
            <div class="col-md-2" v-if="perfil === 'ADMIN' || perfil === 'DIRETOR'">
              <label class="mb-0 small text-muted font-weight-bold">Coordenação</label>
              <select class="form-control form-control-sm" v-model="filtro.coordenacao" @change="changeCoordenacao()">
                <option value="">Todas</option>
                <option v-for="c in listaCoordenacaoFiltroFiltrada" :key="c.idcoordenacao" :value="c.idcoordenacao">{{ c.sigla }}</option>
              </select>
            </div>
            <div class="col-md-4">
              <label class="mb-0 small text-muted font-weight-bold">Grupo de Trabalho</label>
              <select class="form-control form-control-sm" v-model="filtro.gt" @change="changeGt()">
                <option value="">Todos</option>
                <option v-for="g in listaGtFiltroFiltrada" :key="g.idgt" :value="g.idgt">{{ g.nomeComCoord || g.nome }}</option>
              </select>
            </div>
            <div class="col-md-4">
              <label class="mb-0 small text-muted font-weight-bold">Responsável</label>
              <select class="form-control form-control-sm" v-model="filtro.responsavel" @change="aplicarFiltro()" :disabled="carregandoResponsaveis">
                <option value="" v-if="!carregandoResponsaveis">Todos</option>
                <option value="" v-else>Pesquisando...</option>
                <option v-for="r in listaResponsavelFiltro" :key="r.idusuario" :value="r.idusuario">{{ r.nome }}</option>
              </select>
            </div>
          <!--</div>
          <div class="row align-items-end">-->
            <div class="col-md-2">
              <label class="mb-0 small text-muted font-weight-bold">Data Início (a partir de)</label>
              <flat-picker class="form-control form-control-sm bg-white" v-model="filtro.dataInicio" placeholder="Início" :config="{ allowInput: true, dateFormat: 'd/m/Y' }" @on-change="aplicarFiltro()" @input="aplicarFiltro()"></flat-picker>
            </div>
            <div class="col-md-2">
              <label class="mb-0 small text-muted font-weight-bold">Data Fim (até)</label>
              <flat-picker class="form-control form-control-sm bg-white" v-model="filtro.dataFim" placeholder="Fim" :config="{ allowInput: true, dateFormat: 'd/m/Y' }" @on-change="aplicarFiltro()" @input="aplicarFiltro()"></flat-picker>
            </div>
            <div :class="(perfil === 'ADMIN' || perfil === 'DIRETOR') ? 'col-md-2 mt-2' : 'col-md-4 mt-2'">
              <label class="mb-0 small text-muted font-weight-bold">Situação</label>
              <select class="form-control form-control-sm" v-model="filtro.situacao" @change="aplicarFiltro()">
                <option value="">Todas</option>
                <option v-for="s in listaSituacao" :key="s.codigo" :value="s.codigo">{{ s.descricao }}</option>
              </select>
            </div>
            <div :class="(perfil === 'ADMIN' || perfil === 'DIRETOR') ? 'col-md-4' : 'col-md-6'">
              <label class="mb-0 small text-muted font-weight-bold">Buscar (Descrição, Código, KR, Projeto, Atividade)</label>
              <input type="text" class="form-control form-control-sm" v-model="filtro.descricao" @keyup="aplicarFiltro()" placeholder="Pesquisar..."/>
            </div>
            <div class="col-md-2">
              <button type="button" class="btn btn-secondary btn-sm w-100" @click="limparFiltro()">
                <i class="fas fa-times mr-1"></i>Limpar
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- TOTALIZADORES -->
      <div class="row">
        <div class="col">
          <div class="card text-left p-1 total-card total-total">
            <div class="total-label ml-2">Total de OKRs</div>
            <div class="total-num ml-2">{{ listaOkrFiltrada.length }}</div>
          </div>
        </div>
        <div class="col">
          <div class="card text-left p-1 total-card total-total-kr">
            <div class="total-label ml-2">Total de KRs</div>
            <div class="total-num ml-2">{{ totalKrsGeral() }}</div>
          </div>
        </div>
        <div class="col">
          <div class="card text-left p-1 total-card total-progresso">
            <div class="total-label ml-2">Progresso médio OKRs</div>
            <div class="total-num-porc text-center">{{ progressoMedioGeral() }}%</div>
            <div class="progress ml-2 mr-2 mb-1 mt-1" style="height: 4px; background-color: #e9ecef;">
              <div class="progress-bar" :class="corBarraProgresso(progressoMedioGeral())" :style="'width: ' + progressoMedioGeral() + '%'"></div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card text-left p-1 total-card total-andamento">
            <div class="total-label ml-2">OKRs - Em Andamento</div>
            <div class="total-num ml-2 text-info">{{ totalPorSituacao('EMANDAMENTO') }}</div>
          </div>
        </div>
        <div class="col">
          <div class="card text-left p-1 total-card total-concluido">
            <div class="total-label ml-2">OKRs - Concluídos</div>
            <div class="total-num ml-2 text-success">{{ totalPorSituacao('CONCLUIDO') }}</div>
          </div>
        </div>
        <div class="col">
          <div class="card text-left p-1 total-card total-cancelado">
            <div class="total-label ml-2">OKRs - Cancelados</div>
            <div class="total-num ml-2 text-danger">{{ totalPorSituacao('CANCELADO') }}</div>
          </div>
        </div>
      </div>

      <!-- ESTRATÉGICOS -->
      <div class="card mb-2">
        <div class="card-header secao-header" @click="accordionEstrategico = !accordionEstrategico" style="cursor:pointer;">
          <strong><i class="fas fa-bullseye mr-2 text-primary"></i>Estratégicos ({{ totalFiltradoPorTipo('ESTRATEGICO') }})</strong>
          <i :class="accordionEstrategico ? 'fas fa-chevron-up float-right' : 'fas fa-chevron-down float-right'"></i>
        </div>
        <div v-show="accordionEstrategico">
          <div v-for="okr in okrsPorTipoFiltrada('ESTRATEGICO')" :key="okr.idokr" class="okr-item border-bottom" :class="{ 'okr-item-aberto': okrAberto(okr.idokr) }">
            <div class="okr-header row align-items-center p-3 m-0" :class="{ 'okr-header-aberto': okrAberto(okr.idokr) }"
              @click="toggleOkr(okr.idokr)" style="cursor:pointer;">
				<div class="col-md-6">
					<strong :style="okrCancelado(okr.situacao)">{{ addMascaraCodigo("OKR", okr.idokr) }} - {{ okr.descricao }}</strong>
					<div class="small text-muted mt-1" v-if="okr.grupoTrabalho">
						<i class="fas fa-users mr-1"></i> {{ okr.grupoTrabalho.nome }}
						<span v-if="okr.grupoTrabalho.coordenacao"> &bull; {{ okr.grupoTrabalho.coordenacao.siglaNome || (okr.grupoTrabalho.coordenacao.sigla + ' - ' + okr.grupoTrabalho.coordenacao.nome) }}</span>
					</div>
				</div>
				<div class="col text-center">
					<span v-for="resp in okr.listaResponsavel" :key="resp.idusuario" style="margin-left: -10px;">
					<el-tooltip :content="resp.nome" placement="top">
						<img :src="resp.avatar" :title="resp.nome" width="27" class="rounded-circle">
					</el-tooltip>
					</span>
				</div>
				<div class="col text-center">
					<span class="text-nowrap" :class="corSituacaoTexto(okr.situacao)"> {{ okr.situacaoDescricao }}</span>
				</div>
				<div class="col text-center text-muted small text-nowrap">
					{{ okr.dataInicio }} a {{ okr.dataFim }}
				</div>
				<div class="col text-center">
					<div class="total-num-porc text-center" style="font-size: 12px; margin-bottom: 2px;">{{ formatarProgressoExibicao(okr.progresso) }}%</div>
					<el-tooltip :content="'Progresso: '+ formatarProgressoExibicao(okr.progresso) +'%'" placement="top">
						<div class="progress" style="height: 5px;">
						<div class="progress-bar" :class="corBarraProgresso(okr.progresso)" :style="'width:' + formatarProgresso(okr.progresso) + '%'"></div>
						</div>
					</el-tooltip>
				</div>
        <div class="col-md-2 ml--5 text-right">
          <el-tooltip content="Alterar Objetivo" placement="top" v-if="podeEditarObjetivo(okr)">
						<i class="fas fa-edit text-info mr-2" @click.stop="editarOkr(okr.idokr)"></i>
					</el-tooltip>
          <el-tooltip content="Cancelar Objetivo" placement="top" v-if="okr.situacao === 'EMANDAMENTO' && (isAdmin() || isResponsavelOkr(okr))">
						<i class="fas fa-ban text-danger mr-2" @click.stop="cancelarOkr(okr)"></i>
					</el-tooltip>
          <el-tooltip content="Concluir Objetivo" placement="top" v-if="okr.situacao === 'EMANDAMENTO' && (isAdmin() || isResponsavelOkr(okr))">
						<i class="far fa-check-circle text-success mr-2" @click.stop="concluirOkr(okr)"></i>
					</el-tooltip>
          <el-tooltip content="Vincular Projeto" placement="top" v-if="podeGerenciarProjeto(okr)">
            <i class="fas fa-link text-success mr-3" @click.stop="abrirModalVincularProjeto(okr)"></i>
					</el-tooltip>
					<i :class="okrAberto(okr.idokr) ? 'fas fa-chevron-up text-muted' : 'fas fa-chevron-down text-muted'"></i>
				</div>
            </div>

            <div v-if="okrAberto(okr.idokr)" class="okr-detalhe pl-3 pr-3 mt-1">

        <div class="row mt-2 px-1">
          <div class="col-md-3 mb--2">
						<div class="card text-left p-1 total-card total-total">
							<div class="total-label ml-2">Total de KRs</div>
							<div class="total-num ml-2"> {{ okr.listaIndicador.length }} </div>
						</div>
					</div>
          <div class="col-md-3 mb--2">
						<div class="card text-left p-1 total-card total-total-kr">
							<div class="total-label ml-2">Total de projetos</div>
							<div class="total-num ml-2"> {{okr.listaProjeto.length}} </div>
						</div>
					</div>
          <div class="col-md-3 mb--2">
						<div class="card text-left p-1 total-card total-total-kr">
							<div class="total-label ml-2">Total de atividades</div>
							<div class="total-num ml-2"> {{ totalizarAtividades(okr.listaProjeto) }} </div>
						</div>
					</div>
          <div class="col-md-3 mb--2">
            <div class="card text-left p-1 total-card total-investimento-okr">
              <div class="total-label ml-2">Investimento no OKR</div>
              <div class="total-num-data ml-2 text-dark">{{ formatarMoeda(totalInvestimentoOkr(okr.listaProjeto)) }}</div>
            </div>
          </div>
          <div class="col-md-3 mb--2">
            <div class="card text-left p-1 total-card total-total-kr-nao-iniciado">
              <div class="total-label ml-2">KRs - Não iniciados</div>
              <div class="total-num ml-2 text-secondary"> {{ totalKrsPorSituacao(okr, 'NAO_INICIADO') }} </div>
            </div>
          </div>
          <div class="col-md-3 mb--2">
            <div class="card text-left p-1 total-card total-andamento">
              <div class="total-label ml-2">KRs - Em andamento</div>
              <div class="total-num ml-2 text-info"> {{ totalKrsPorSituacao(okr, 'EM_ANDAMENTO') }} </div>
            </div>
          </div>
          <div class="col-md-3 mb--2">
            <div class="card text-left p-1 total-card total-concluido">
              <div class="total-label ml-2">KRs - Alcançados</div>
              <div class="total-num ml-2 text-success"> {{ totalKrsPorSituacao(okr, 'ALCANCADO') }} </div>
            </div>
          </div>
          <div class="col-md-3 mb--2">
            <div class="card text-left p-1 total-card total-cancelado">
              <div class="total-label ml-2">KRs - Cancelados</div>
              <div class="total-num ml-2 text-danger"> {{ totalKrsPorSituacao(okr, 'CANCELADO') }} </div>
            </div>
          </div>
				</div>
				

              <!-- INDICADORES -->
              <div class="d-flex justify-content-between align-items-center mt-2 ml-2 mr-2">
                <h6 class="mb-0"><i class="fas fa-chart-line mr-1 text-primary mr-2"></i> Indicadores / KRs</h6>
                <div class="mb-2 mr-2" v-if="okr.situacao === 'EMANDAMENTO' && podeEditar(okr)">
                  <el-tooltip content="Criar Novo Indicador" placement="top">
                    <button type="button" class="btn btn-outline-info btn-sm" @click.stop="abrirModalNovoIndicador(okr)">
                      <i class="fas fa-plus"></i>
                    </button>
                  </el-tooltip>
                </div>
              </div>
              <div class="row ml-1 mr-1 mb-1 mt--3 text-muted" style="font-size: 11px; font-weight: bold;" v-if="okr.listaIndicador && okr.listaIndicador.length > 0">
                <div class="col-md-4"></div>
                <div class="col-md-1 text-center">Baseline</div>
                <div class="col-md-1 text-center">Atual</div>
                <div class="col-md-1 text-center">Meta</div>
                <div class="col-md-1 text-center">Progresso</div>
                <div class="col-md-1 text-center">Confiança</div>
                <div class="col-md-2 text-center">Atualizado em</div>
                <div class="col-md-1 text-right pr-4"></div>
              </div>

              <div class="accordion" :id="'accordionHist_okr' + okr.idokr">
                <div v-for="(ind, idx) in okr.listaIndicador" :key="ind.idindicador" class="indicador-card mb-2 p-2">
                  <div class="d-flex justify-content-between align-items-center indicator-toggle collapsed" style="cursor: pointer;"
                       data-toggle="collapse" :data-target="'#collapseHist' + ind.idindicador" aria-expanded="false" :aria-controls="'collapseHist' + ind.idindicador">
                    
                    <div class="flex-grow-1">
                      <div class="row align-items-center">
                        <div class="col-md-4">
                          <i class="fas fa-chevron-down mr-1 text-muted" style="font-size: 12px;"></i>
                          <strong style="font-size: 13px;" :style="okrCancelado(okr.situacao)">{{ mascaraKr(okr, idx) }} - {{ ind.descricao }}</strong>
                          <br>
                          <el-tooltip v-if="ind.situacao === 'EM_ANDAMENTO' && ind.diasParaAtualizacao !== null && ind.diasParaAtualizacao !== undefined && ind.diasParaAtualizacao < 0" :content="tooltipPrazoAtualizacao(ind.diasParaAtualizacao)" placement="top">
                            <i class="fas fa-exclamation-triangle text-danger ml-2" style="font-size:11px;"></i>
                          </el-tooltip>
                          <el-tooltip v-if="ind.tipoIndicadorDescricao" :content="'Tipo: ' + ind.tipoIndicadorDescricao" placement="top">
                            <span class="badge badge-secondary ml-2" style="font-size:10px;">{{ tipoIndicadorBadge(ind.tipoIndicador) }}</span>
                          </el-tooltip>
                          <el-tooltip v-if="ind.sentidoDescricao" :content="ind.sentidoDescricao" placement="top">
                            <i class="ml-2" :class="ind.sentido === 'MAIORMELHOR' ? 'fas fa-arrow-up text-success' : 'fas fa-arrow-down text-info'" style="font-size:12px;"></i>
                          </el-tooltip>
                          <el-tooltip v-if="ind.fonte" content="Ver Fonte de Verificação" placement="top">
                            <i class="fas fa-link text-muted ml-2" style="font-size:11px; cursor:pointer;" @click.stop="abrirModalFonte(ind)"></i>
                          </el-tooltip>
                          <span v-if="ind.situacaoDescricao" class="ml-2" style="font-size:11px; font-weight:600;" :class="corSituacaoKrTexto(ind.situacao)">{{ ind.situacaoDescricao }}</span>
                        </div>
                        <div class="col-md-1 text-center" style="font-size: 13px;">{{ ind.baseline }}</div>
                        <div class="col-md-1 text-center" style="font-size: 13px; font-weight: bold;">{{ ind.atual }}</div>
                        <div class="col-md-1 text-center" style="font-size: 13px;">{{ ind.meta }}</div>
                        <div class="col-md-1 text-center">
                          <div class="total-num-porc text-center" style="font-size: 12px; margin-bottom: 2px;">{{ formatarProgressoExibicao(ind.progresso) }}%</div>
                          <el-tooltip :content="'Progresso: '+ formatarProgressoExibicao(ind.progresso) +'%'" placement="top">
                            <div class="progress" style="height: 5px;">
                              <div class="progress-bar" :class="corBarraProgresso(ind.progresso)"
                                  :style="'width:' + formatarProgresso(ind.progresso) + '%'">
                              </div>
                            </div>
                          </el-tooltip>
                        </div>
                        <div class="col-md-1 text-center">
                          <div class="total-num-porc text-center" style="font-size: 12px; margin-bottom: 2px;">{{ ind.confianca !== null ? ind.confianca + '/10' : '-' }}</div>
                          <el-tooltip v-if="ind.confianca !== null" :content="'Confiança: ' + ind.confianca + '/10'" placement="top">
                            <div class="progress" style="height: 5px;">
                              <div class="progress-bar" :class="corBarraConfianca(ind.confianca)" :style="'width: ' + (ind.confianca * 10) + '%'"></div>
                            </div>
                          </el-tooltip>
                          <div v-else class="progress" style="height: 5px; background-color: transparent;"></div>
                        </div>
                        <div class="col-md-2 text-center" style="font-size: 12px;">
                          <span :class="corPrazoAtualizacao(ind.diasParaAtualizacao)">
                            {{ ind.dataAtualizacao || '-' }}
                            <el-tooltip v-if="ind.situacao === 'EM_ANDAMENTO' && ind.diasParaAtualizacao !== null && ind.diasParaAtualizacao !== undefined" :content="tooltipPrazoAtualizacao(ind.diasParaAtualizacao)" placement="top">
                              <i :class="ind.diasParaAtualizacao < 0 ? 'fas fa-exclamation-triangle ml-1' : 'fas fa-clock ml-1'" style="font-size:11px; cursor:default;"></i>
                            </el-tooltip>
                          </span>
                        </div>
                        <div class="col-md-1 text-right">
                          <template v-if="okr.situacao === 'EMANDAMENTO' && podeEditar(okr) && (podeMoverKr(ind) || isAdmin())">
                          <el-tooltip v-if="ind.situacao !== 'NAO_INICIADO' && podeMoverKr(ind)" content="Atualizar Indicador" placement="top">
                            <i class="fas fa-edit text-info mr-1" style="cursor:pointer;" @click.stop="abrirModalAtualizar(okr.idokr, ind)"></i>
                          </el-tooltip>
                          <el-tooltip content="Iniciar KR" placement="top" v-if="ind.situacao === 'NAO_INICIADO'">
                            <i class="far fa-play-circle text-success mr-1" style="cursor:pointer;" @click.stop="alterarSituacaoKr(okr.idokr, ind, 'EM_ANDAMENTO')"></i>
                          </el-tooltip>
                          <el-tooltip content="Concluir KR" placement="top" v-if="ind.situacao === 'EM_ANDAMENTO'">
                            <i class="far fa-check-circle text-success mr-1" style="cursor:pointer;" @click.stop="alterarSituacaoKr(okr.idokr, ind, 'ALCANCADO')"></i>
                          </el-tooltip>
                          <el-tooltip content="Cancelar KR" placement="top" v-if="ind.situacao === 'NAO_INICIADO' || ind.situacao === 'EM_ANDAMENTO'">
                            <i class="fas fa-ban text-danger mr-1" style="cursor:pointer;" @click.stop="alterarSituacaoKr(okr.idokr, ind, 'CANCELADO')"></i>
                          </el-tooltip>
                          <el-tooltip content="Voltar Indicador" placement="top" v-if="(ind.situacao === 'ALCANCADO' || ind.situacao === 'CANCELADO') && isAdmin()">
                            <i class="fas fa-undo text-warning mr-1" style="cursor:pointer;" @click.stop="alterarSituacaoKr(okr.idokr, ind, 'REVERTER')"></i>
                          </el-tooltip>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- HISTÓRICO DO INDICADOR -->
                  <div v-if="ind.listaHistorico && ind.listaHistorico.length > 0">
                    <div :id="'collapseHist' + ind.idindicador" class="collapse" :data-parent="'#accordionHist_okr' + okr.idokr">
                      <div class="card-body p-2 mt-2" style="border-top: 1px solid #e9ecef;">
                        <div class="row">
                          <div :class="ind.listaHistorico.length >= 3 ? 'col-md-7' : 'col-md-12'">
                            <table class="table table-sm table-striped mt-1">
                              <thead>
                                <tr>
                                  <th class="text-center">Data</th>
                                  <th class="text-center">Valor</th>
                                  <th class="text-center">Confiança</th>
                                  <th>Observação</th>
                                  <th>Alterado por</th>
                                  <th v-if="isAdmin()" class="text-center" style="width: 50px;"></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="hist in ordenarHistoricoRecentePrimeiro(ind.listaHistorico)" :key="hist.idhistorico">
                                  <td class="text-center">{{ hist.dataAtualizacao }}</td>
                                  <td class="text-center">{{ hist.valor }}</td>
                                  <td class="text-center">{{ hist.confianca }}/10</td>
                                  <td>
                                    <el-tooltip v-if="hist.observacao && hist.observacao.length > 20" :content="hist.observacao" placement="top">
                                      <span>{{ resumirObservacao(hist.observacao) }}</span>
                                    </el-tooltip>
                                    <span v-else>{{ hist.observacao || '-' }}</span>
                                  </td>
                                  <td>
                                    <el-tooltip v-if="hist.nomeUsuario && hist.nomeUsuario.length > 20" :content="hist.nomeUsuario" placement="top">
                                      <span>{{ resumirObservacao(hist.nomeUsuario) }}</span>
                                    </el-tooltip>
                                    <span v-else>{{ hist.nomeUsuario || '-' }}</span>
                                  </td>
                                  <td v-if="isAdmin()" class="text-center">
                                    <el-tooltip content="Excluir histórico" placement="top">
                                      <span style="z-index: 1; position: absolute; cursor: pointer;" @click="excluirHistoricoIndicador(okr.idokr, ind.idindicador, hist.idhistorico)">
                                        <i class="fas fa-trash text-muted"></i>
                                      </span>
                                    </el-tooltip>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div class="col-md-5" v-if="ind.listaHistorico.length >= 3">
                            <small class="text-muted font-weight-bold ml-6"><span class="text-info">Progresso (%)</span> e <span class="text-success">Confiança</span></small>
                            <div class="pl-5 pr-5 pt-3">
                              <Linha :key="ind.idindicador + '_' + chartVersion" styles="height: 200px;" :chartdata="getChartDataHistorico(ind)" :options="optionsLinha"></Linha>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- PROJETOS VINCULADOS - ESTRATÉGICOS -->
              <div class="mb-3">
                <div class="d-flex justify-content-between align-items-center mt-1 ml-2 mr-2">
                  <h6 class="mb-0"><i class="fas fa-project-diagram mr-1 text-success mr-2"></i> Projeto(s) Vinculado(s) ({{okr.listaProjeto.length}})</h6>
                  <div class="mb-2 mr-2">
                    <el-tooltip content="Vincular Projeto" placement="top" v-if="podeGerenciarProjeto(okr)">
                      <button type="button" class="btn btn-outline-success btn-sm" @click.stop="abrirModalVincularProjeto(okr)">
                        <i class="fas fa-link"></i>
                      </button>
                    </el-tooltip>
                    <el-tooltip content="Criar Novo Projeto" placement="top">
                      <button v-if="okr.situacao === 'EMANDAMENTO'" type="button" 
                        class="btn btn-outline-success btn-sm" @click.stop="abrirModalCriarProjeto(okr)">
                        <i class="fas fa-plus"></i>
                      </button>
                    </el-tooltip>
                  </div>
                </div>

                <div v-if="okr.listaProjeto && okr.listaProjeto.length > 0" class="accordion" :id="'accordionProj' + okr.idokr">
                  <div id="accordProjeto" class="card shadow-none mb-1 projeto-item-aberto" style="border: 1px solid #e9ecef; border-radius: 10px;" v-for="p in okr.listaProjeto" :key="p.idprojeto">
                    <div class="card-header p-2 bg-light" :id="'headingProj' + p.idprojeto" style="cursor: pointer;"
                      @click="toggleProjeto(okr.idokr, p.idprojeto)"
                         data-toggle="collapse" :data-target="'#collapseProj' + p.idprojeto" aria-expanded="false" :aria-controls="'collapseProj' + p.idprojeto">
                      
                      <!-- PROJETO HEADER -->
                      <div class="row align-items-center m-0 projeto-header">
                        <div class="col-md-6">
                          <i class="far fa-calendar-check text-secondary mr-2"></i> {{ p.codigoNome }}
                        </div>
                        <div class="col-md-1 text-center">
                          <span v-for="resp in p.listaResponsavel" :key="resp.idusuario" style="margin-left: -10px;">
                            <el-tooltip :content="resp.nome" placement="top">
                              <img :src="resp.avatar" :title="resp.nome" width="27" class="rounded-circle border border-white">
                            </el-tooltip>
                          </span>
                        </div>
                        <div class="col-md-2 text-center">
                          <span :class="corSituacaoProjetoTexto(p.situacao)"> {{ p.situacaoDescricao }}</span>
                        </div>
                        <div class="col-md-2 small text-muted text-center">
                          {{ p.dataInicio }} a {{ p.dataFim }}
                        </div>
                        <div class="col-md-1 text-center" style="margin-left: -22px;">
                          <el-tooltip content="Visualizar Projeto" placement="top">
                            <i class="fas fa-eye text-secondary mr-2" style="cursor:pointer;" @click.stop="abrirModalVisualizarProjeto(p)"></i>
                          </el-tooltip>
                          <template v-if="podeAdicionarAtividade(okr, p)">
                            <el-tooltip content="Adicionar Atividade" placement="top">
                              <i class="fas fa-calendar-plus text-primary mr-2" style="cursor:pointer;" @click.stop="abrirModalCriarAtividade(okr, p)"></i>
                            </el-tooltip>
                          </template>
                          <el-tooltip content="Desvincular Projeto" placement="top" v-if="podeGerenciarProjeto(okr)">
                            <i class="fas fa-unlink text-danger" style="cursor:pointer;" @click.stop="desvincularprojeto(okr, p)"></i>
                          </el-tooltip>
                        </div>
                      </div>
                    </div>
                    
                    <div :id="'collapseProj' + p.idprojeto" class="collapse" :aria-labelledby="'headingProj' + p.idprojeto" :data-parent="'#accordionProj' + okr.idokr">
                      <div class="card-body p-2 bg-white">
                        
                        <div v-if="!p.listaAtividade || p.listaAtividade.length === 0" class="text-muted small ml-3">
                          Nenhuma atividade encontrada.
                        </div>

                        <!-- ACCORDION ATIVIDADES -->
                        <div class="accordion" :id="'accordionAtiv' + p.idprojeto" v-if="p.listaAtividade && p.listaAtividade.length > 0">
                          <div class="card shadow-none border-0 mb-1" v-for="a in p.listaAtividade" :key="a.idatividade">
                            <div class="card-header p-2" :id="'headingAtiv' + a.idatividade" style="cursor: pointer; background-color: #fcfcfc; border-bottom: 1px solid #f1f1f1;"
                                 data-toggle="collapse" :data-target="'#collapseAtiv' + a.idatividade" aria-expanded="false" :aria-controls="'collapseAtiv' + a.idatividade">
                              
                              <!-- ATIVIDADE HEADER -->
                              <div class="row align-items-center m-0 projeto-header">
                                <div class="col-md-6 pl-3">
                                  <i class="fas fa-calendar-check text-secondary mr-2"></i> {{ a.codigoNome }}
                                </div>
                                <div class="col-md-1 text-center">
                                  <span v-for="resp in a.listaResponsavel" :key="resp.idusuario" style="margin-left: -10px;">
                                    <el-tooltip :content="resp.nome" placement="top">
                                      <img :src="resp.avatar" :title="resp.nome" width="24" class="rounded-circle border border-white">
                                    </el-tooltip>
                                  </span>
                                </div>
                                <div class="col-md-2 text-center">
                                  <span :class="corSituacaoAtividadeTexto(a.situacao)"> {{ a.situacaoDescricao }}</span>
                                </div>
                                <div class="col-md-2 small text-muted text-center">
                                  {{ a.dataInicio }} a {{ a.dataFim }}
                                </div>
                                <div class="col-md-1 text-center" style="margin-left: -12px;">
                                  <el-tooltip content="Visualizar Atividade" placement="top">
                                    <i class="fas fa-eye text-secondary" style="cursor:pointer;" @click.stop="abrirModalVisualizarAtividade(a)"></i>
                                  </el-tooltip>
                                </div>
                              </div>
                            </div>
                            
                            <div :id="'collapseAtiv' + a.idatividade" class="collapse" :aria-labelledby="'headingAtiv' + a.idatividade" :data-parent="'#accordionAtiv' + p.idprojeto">
                              <div class="card-body p-1 pl-4">
                                
                                <div v-if="!a.listaTarefa || a.listaTarefa.length === 0" class="text-muted small ml-3 mt-1 mb-1">
                                  Nenhuma tarefa encontrada.
                                </div>

                                <!-- LISTA DE TAREFAS -->
                                <div class="row align-items-center m-0 border-bottom py-1 projeto-header" v-for="t in a.listaTarefa" :key="t.idtarefa">
                                  <div class="col-md-7 pl-3">
                                    <small><i class="fas fa-tasks text-secondary mr-2"></i> {{ t.codigoNome }}</small>
                                  </div>
                                  <div class="col-md-2 text-center">
                                    <span :class="corSituacaoAtividadeTexto(t.situacao)"> {{ t.situacaoDescricao }}</span>
                                  </div>
                                  <div class="col-md-3 text-muted text-center" style="font-size: 11px;">
                                    {{ t.dataInicio }} a {{ t.dataFim }}
                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="text-muted small ml-3 mb-2">Nenhum projeto vinculado.</div>
              </div>
            </div>
          </div>
          <div v-if="okrsPorTipoFiltrada('ESTRATEGICO').length === 0" class="p-3 text-center text-muted">
            Nenhum Objetivo Estratégico.
          </div>
        </div>
      </div>

      <!-- GERAIS -->
      <div class="card mb-2">
        <div class="card-header secao-header" @click="accordionGeral = !accordionGeral" style="cursor:pointer;">
          <strong><i class="fas fa-layer-group mr-2 text-info"></i>Gerais ({{ totalFiltradoPorTipo('GERAL') }})</strong>
          <i :class="accordionGeral ? 'fas fa-chevron-up float-right' : 'fas fa-chevron-down float-right'"></i>
        </div>
        <div v-show="accordionGeral">
          <div v-for="okr in okrsPorTipoFiltrada('GERAL')" :key="okr.idokr" class="okr-item border-bottom" :class="{ 'okr-item-aberto': okrAberto(okr.idokr) }">
            <div class="okr-header row align-items-center p-3 m-0" :class="{ 'okr-header-aberto': okrAberto(okr.idokr) }"
              @click="toggleOkr(okr.idokr)" style="cursor:pointer;">
              <div class="col-md-6 mb-2">
                <strong :style="okrCancelado(okr.situacao)">{{ addMascaraCodigo("OKR", okr.idokr) }} - {{ okr.descricao }}</strong>
                <div class="small text-muted mt-1" v-if="okr.grupoTrabalho">
                  <i class="fas fa-users mr-1"></i> {{ okr.grupoTrabalho.nome }}
                  <span v-if="okr.grupoTrabalho.coordenacao"> &bull; {{ okr.grupoTrabalho.coordenacao.siglaNome || (okr.grupoTrabalho.coordenacao.sigla + ' - ' + okr.grupoTrabalho.coordenacao.nome) }}</span>
                </div>
              </div>
              <div class="col text-center">
                <span v-for="resp in okr.listaResponsavel" :key="resp.idusuario" style="margin-left: -10px;">
                  <el-tooltip :content="resp.nome" placement="top">
                    <img :src="resp.avatar" :title="resp.nome" width="27" class="rounded-circle">
                  </el-tooltip>
                </span>
              </div>
              <div class="col text-center">
                <span class="text-nowrap" :class="corSituacaoTexto(okr.situacao)"> {{ okr.situacaoDescricao }}</span>
              </div>
              <div class="col text-center text-muted small text-nowrap">
                {{ okr.dataInicio }} a {{ okr.dataFim }}
              </div>
              <div class="col text-center">
                <div class="total-num-porc text-center" style="font-size: 12px; margin-bottom: 2px;">{{ formatarProgressoExibicao(okr.progresso) }}%</div>
                <el-tooltip :content="'Progresso: '+ formatarProgressoExibicao(okr.progresso) +'%'" placement="top">
                  <div class="progress" style="height: 5px;">
                    <div class="progress-bar" :class="corBarraProgresso(okr.progresso)" :style="'width:' + formatarProgresso(okr.progresso) + '%'"></div>
                  </div>
                </el-tooltip>
              </div>
              <div class="col-md-2 ml--5 text-right">
                <el-tooltip content="Alterar Objetivo" placement="top" v-if="podeEditarObjetivo(okr)">
                  <i class="fas fa-edit text-info mr-2" @click.stop="editarOkr(okr.idokr)"></i>
                </el-tooltip>
                <el-tooltip content="Cancelar Objetivo" placement="top" v-if="okr.situacao === 'EMANDAMENTO' && (isAdmin() || isResponsavelOkr(okr))">
                  <i class="fas fa-ban text-danger mr-2" @click.stop="cancelarOkr(okr)"></i>
                </el-tooltip>
                <el-tooltip content="Concluir Objetivo" placement="top" v-if="okr.situacao === 'EMANDAMENTO' && (isAdmin() || isResponsavelOkr(okr))">
                  <i class="far fa-check-circle text-success mr-2" @click.stop="concluirOkr(okr)"></i>
                </el-tooltip>
                <el-tooltip content="Vincular Projeto" placement="top" v-if="podeGerenciarProjeto(okr)">
                  <i class="fas fa-link text-success mr-3" @click.stop="abrirModalVincularProjeto(okr)"></i>
                </el-tooltip>
                <i :class="okrAberto(okr.idokr) ? 'fas fa-chevron-up text-muted' : 'fas fa-chevron-down text-muted'"></i>
              </div>
            </div>

            <div v-if="okrAberto(okr.idokr)" class="okr-detalhe pl-3 pr-3 mt-1">

        <div class="row mt-2 px-1">
          <div class="col-md-3 mb--2">
						<div class="card text-left p-1 total-card total-total">
							<div class="total-label ml-2">Total de KRs</div>
							<div class="total-num ml-2"> {{ okr.listaIndicador.length }} </div>
						</div>
					</div>
          <div class="col-md-3 mb--2">
						<div class="card text-left p-1 total-card total-total-kr">
							<div class="total-label ml-2">Total de projetos</div>
							<div class="total-num ml-2"> {{okr.listaProjeto.length}} </div>
						</div>
					</div>
          <div class="col-md-3 mb--2">
						<div class="card text-left p-1 total-card total-total-kr">
							<div class="total-label ml-2">Total de atividades</div>
							<div class="total-num ml-2"> {{ totalizarAtividades(okr.listaProjeto) }} </div>
						</div>
					</div>
          <div class="col-md-3 mb--2">
            <div class="card text-left p-1 total-card total-investimento-okr">
              <div class="total-label ml-2">Investimento do OKR</div>
              <div class="total-num-data ml-2 text-dark">{{ formatarMoeda(totalInvestimentoOkr(okr.listaProjeto)) }}</div>
            </div>
          </div>
          <div class="col-md-3 mb--2">
            <div class="card text-left p-1 total-card total-total-kr-nao-iniciado">
              <div class="total-label ml-2">KRs - Não iniciados</div>
              <div class="total-num ml-2 text-secondary"> {{ totalKrsPorSituacao(okr, 'NAO_INICIADO') }} </div>
            </div>
          </div>
          <div class="col-md-3 mb--2">
            <div class="card text-left p-1 total-card total-andamento">
              <div class="total-label ml-2">KRs - Em andamentos</div>
              <div class="total-num ml-2 text-info"> {{ totalKrsPorSituacao(okr, 'EM_ANDAMENTO') }} </div>
            </div>
          </div>
          <div class="col-md-3 mb--2">
            <div class="card text-left p-1 total-card total-concluido">
              <div class="total-label ml-2">KRs - Alcançados</div>
              <div class="total-num ml-2 text-success"> {{ totalKrsPorSituacao(okr, 'ALCANCADO') }} </div>
            </div>
          </div>
          <div class="col-md-3 mb--2">
            <div class="card text-left p-1 total-card total-cancelado">
              <div class="total-label ml-2">KRs - Cancelados</div>
              <div class="total-num ml-2 text-danger"> {{ totalKrsPorSituacao(okr, 'CANCELADO') }} </div>
            </div>
          </div>
				</div>

              <!-- INDICADORES -->
              <div class="d-flex justify-content-between align-items-center mt-2 ml-2 mr-2">
                <h6 class="mb-0"><i class="fas fa-chart-line mr-1 text-primary mr-2"></i> Indicadores / KRs</h6>
                <div class="mb-2 mr-2" v-if="okr.situacao === 'EMANDAMENTO' && podeEditar(okr)">
                  <el-tooltip content="Criar Novo Indicador" placement="top">
                    <button type="button" class="btn btn-outline-info btn-sm" @click.stop="abrirModalNovoIndicador(okr)">
                      <i class="fas fa-plus"></i>
                    </button>
                  </el-tooltip>
                </div>
              </div>
              <div class="row ml-1 mr-1 mb-1 mt--3 text-muted" style="font-size: 11px; font-weight: bold;" v-if="okr.listaIndicador && okr.listaIndicador.length > 0">
                <div class="col-md-4"></div>
                <div class="col-md-1 text-center">Baseline</div>
                <div class="col-md-1 text-center">Atual</div>
                <div class="col-md-1 text-center">Meta</div>
                <div class="col-md-1 text-center">Progresso</div>
                <div class="col-md-1 text-center">Confiança</div>
                <div class="col-md-2 text-center">Atualizado em</div>
                <div class="col-md-1 text-right pr-4"></div>
              </div>

              <div class="accordion" :id="'accordionHist_okr' + okr.idokr">
                <div v-for="(ind, idx) in okr.listaIndicador" :key="ind.idindicador" class="indicador-card mb-2 p-2">
                  <div class="d-flex justify-content-between align-items-center indicator-toggle collapsed" style="cursor: pointer;"
                       data-toggle="collapse" :data-target="'#collapseHist' + ind.idindicador" aria-expanded="false" :aria-controls="'collapseHist' + ind.idindicador">
                    
                    <div class="flex-grow-1">
                      <div class="row align-items-center">
                        <div class="col-md-4">
                          <i class="fas fa-chevron-down mr-1 text-muted" style="font-size: 12px;"></i>
                          <strong style="font-size: 13px;" :style="okrCancelado(okr.situacao)">{{ mascaraKr(okr, idx) }} - {{ ind.descricao }}</strong>
                          <br>
                          <el-tooltip v-if="ind.situacao === 'EM_ANDAMENTO' && ind.diasParaAtualizacao !== null && ind.diasParaAtualizacao !== undefined && ind.diasParaAtualizacao < 0" :content="tooltipPrazoAtualizacao(ind.diasParaAtualizacao)" placement="top">
                            <i class="fas fa-exclamation-triangle text-danger ml-2" style="font-size:11px;"></i>
                          </el-tooltip>
                          <el-tooltip v-if="ind.tipoIndicadorDescricao" :content="'Tipo: ' + ind.tipoIndicadorDescricao" placement="top">
                            <span class="badge badge-secondary ml-2" style="font-size:10px;">{{ tipoIndicadorBadge(ind.tipoIndicador) }}</span>
                          </el-tooltip>
                          <el-tooltip v-if="ind.sentidoDescricao" :content="ind.sentidoDescricao" placement="top">
                            <i class="ml-2" :class="ind.sentido === 'MAIORMELHOR' ? 'fas fa-arrow-up text-success' : 'fas fa-arrow-down text-info'" style="font-size:12px;"></i>
                          </el-tooltip>
                          <el-tooltip v-if="ind.fonte" content="Ver Fonte de Verificação" placement="top">
                            <i class="fas fa-link text-muted ml-2" style="font-size:11px; cursor:pointer;" @click.stop="abrirModalFonte(ind)"></i>
                          </el-tooltip>
                          <span v-if="ind.situacaoDescricao" class="ml-2" style="font-size:11px; font-weight:600;" :class="corSituacaoKrTexto(ind.situacao)">{{ ind.situacaoDescricao }}</span>
                        </div>
                        <div class="col-md-1 text-center" style="font-size: 13px;">{{ ind.baseline }}</div>
                        <div class="col-md-1 text-center" style="font-size: 13px; font-weight: bold;">{{ ind.atual }}</div>
                        <div class="col-md-1 text-center" style="font-size: 13px;">{{ ind.meta }}</div>
                        <div class="col-md-1 text-center">
                          <div class="total-num-porc text-center" style="font-size: 12px; margin-bottom: 2px;">{{ formatarProgressoExibicao(ind.progresso) }}%</div>
                          <el-tooltip :content="'Progresso: '+ formatarProgressoExibicao(ind.progresso) +'%'" placement="top">
                            <div class="progress" style="height: 5px;">
                              <div class="progress-bar" :class="corBarraProgresso(ind.progresso)"
                                  :style="'width:' + formatarProgresso(ind.progresso) + '%'">
                              </div>
                            </div>
                          </el-tooltip>
                        </div>
                        <div class="col-md-1 text-center">
                          <div class="total-num-porc text-center" style="font-size: 12px; margin-bottom: 2px;">{{ ind.confianca !== null ? ind.confianca + '/10' : '-' }}</div>
                          <el-tooltip v-if="ind.confianca !== null" :content="'Confiança: ' + ind.confianca + '/10'" placement="top">
                            <div class="progress" style="height: 5px;">
                              <div class="progress-bar" :class="corBarraConfianca(ind.confianca)" :style="'width: ' + (ind.confianca * 10) + '%'"></div>
                            </div>
                          </el-tooltip>
                          <div v-else class="progress" style="height: 5px; background-color: transparent;"></div>
                        </div>
                        <div class="col-md-2 text-center" style="font-size: 12px;">
                          <span :class="corPrazoAtualizacao(ind.diasParaAtualizacao)">
                            {{ ind.dataAtualizacao || '-' }}
                            <el-tooltip v-if="ind.situacao === 'EM_ANDAMENTO' && ind.diasParaAtualizacao !== null && ind.diasParaAtualizacao !== undefined" :content="tooltipPrazoAtualizacao(ind.diasParaAtualizacao)" placement="top">
                              <i :class="ind.diasParaAtualizacao < 0 ? 'fas fa-exclamation-triangle ml-1' : 'fas fa-clock ml-1'" style="font-size:11px; cursor:default;"></i>
                            </el-tooltip>
                          </span>
                        </div>
                        <div class="col-md-1 text-right">
                          <template v-if="okr.situacao === 'EMANDAMENTO' && podeEditar(okr) && (podeMoverKr(ind) || isAdmin())">
                          <el-tooltip v-if="ind.situacao !== 'NAO_INICIADO' && podeMoverKr(ind)" content="Atualizar Indicador" placement="top">
                            <i class="fas fa-edit text-info mr-1" style="cursor:pointer;" @click.stop="abrirModalAtualizar(okr.idokr, ind)"></i>
                          </el-tooltip>
                          <el-tooltip content="Iniciar KR" placement="top" v-if="ind.situacao === 'NAO_INICIADO'">
                            <i class="far fa-play-circle text-success mr-1" style="cursor:pointer;" @click.stop="alterarSituacaoKr(okr.idokr, ind, 'EM_ANDAMENTO')"></i>
                          </el-tooltip>
                          <el-tooltip content="Concluir KR" placement="top" v-if="ind.situacao === 'EM_ANDAMENTO'">
                            <i class="far fa-check-circle text-success mr-1" style="cursor:pointer;" @click.stop="alterarSituacaoKr(okr.idokr, ind, 'ALCANCADO')"></i>
                          </el-tooltip>
                          <el-tooltip content="Cancelar KR" placement="top" v-if="ind.situacao === 'NAO_INICIADO' || ind.situacao === 'EM_ANDAMENTO'">
                            <i class="fas fa-ban text-danger mr-1" style="cursor:pointer;" @click.stop="alterarSituacaoKr(okr.idokr, ind, 'CANCELADO')"></i>
                          </el-tooltip>
                          <el-tooltip content="Voltar Indicador" placement="top" v-if="(ind.situacao === 'ALCANCADO' || ind.situacao === 'CANCELADO') && isAdmin()">
                            <i class="fas fa-undo text-warning mr-1" style="cursor:pointer;" @click.stop="alterarSituacaoKr(okr.idokr, ind, 'REVERTER')"></i>
                          </el-tooltip>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- HISTÓRICO DO INDICADOR -->
                  <div v-if="ind.listaHistorico && ind.listaHistorico.length > 0">
                    <div :id="'collapseHist' + ind.idindicador" class="collapse" :data-parent="'#accordionHist_okr' + okr.idokr">
                      <div class="card-body p-2 mt-2" style="border-top: 1px solid #e9ecef;">
                        <div class="row">
                          <div :class="ind.listaHistorico.length >= 3 ? 'col-md-7' : 'col-md-12'">
                            <table class="table table-sm table-striped mt-1">
                              <thead>
                                <tr>
                                  <th class="text-center">Data</th>
                                  <th class="text-center">Valor</th>
                                  <th class="text-center">Confiança</th>
                                  <th>Observação</th>
                                  <th>Alterado por</th>
                                  <th v-if="isAdmin()" class="text-center" style="width: 50px;"></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="hist in ordenarHistoricoRecentePrimeiro(ind.listaHistorico)" :key="hist.idhistorico">
                                  <td class="text-center">{{ hist.dataAtualizacao }}</td>
                                  <td class="text-center">{{ hist.valor }}</td>
                                  <td class="text-center">{{ hist.confianca }}/10</td>
                                  <td>
                                    <el-tooltip v-if="hist.observacao && hist.observacao.length > 20" :content="hist.observacao" placement="top">
                                      <span>{{ resumirObservacao(hist.observacao) }}</span>
                                    </el-tooltip>
                                    <span v-else>{{ hist.observacao || '-' }}</span>
                                  </td>
                                  <td>
                                    <el-tooltip v-if="hist.nomeUsuario && hist.nomeUsuario.length > 20" :content="hist.nomeUsuario" placement="top">
                                      <span>{{ resumirObservacao(hist.nomeUsuario) }}</span>
                                    </el-tooltip>
                                    <span v-else>{{ hist.nomeUsuario || '-' }}</span>
                                  </td>
                                  <td v-if="isAdmin()" class="text-center">
                                    <el-tooltip content="Excluir histórico" placement="top">
                                      <span style="z-index: 1; position: absolute; cursor: pointer;" @click="excluirHistoricoIndicador(okr.idokr, ind.idindicador, hist.idhistorico)">
                                        <i class="fas fa-trash text-muted"></i>
                                      </span>
                                    </el-tooltip>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div class="col-md-5" v-if="ind.listaHistorico.length >= 3">
                            <small class="text-muted font-weight-bold ml-6"><span class="text-info">Progresso (%)</span> e <span class="text-success">Confiança</span></small>
                            <div class="pl-5 pr-5 pt-3">
                              <Linha :key="ind.idindicador + '_' + chartVersion" styles="height: 200px;" :chartdata="getChartDataHistorico(ind)" :options="optionsLinha"></Linha>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- PROJETOS VINCULADOS - GERAIS -->
              <div class="mb-3">
                <div class="d-flex justify-content-between align-items-center mt-1 ml-2 mr-2">
                  <h6 class="mb-0"><i class="fas fa-project-diagram mr-1 text-success mr-2"></i> Projeto(s) Vinculado(s) ({{okr.listaProjeto.length}})</h6>
                  <div class="mb-2 mr-2">
                    <el-tooltip content="Vincular Projeto" placement="top" v-if="podeGerenciarProjeto(okr)">
                      <button type="button" class="btn btn-outline-success btn-sm" @click.stop="abrirModalVincularProjeto(okr)">
                        <i class="fas fa-link"></i>
                      </button>
                    </el-tooltip>
                    <el-tooltip content="Criar Novo Projeto" placement="top">
                      <button v-if="okr.situacao === 'EMANDAMENTO'" type="button" 
                        class="btn btn-outline-success btn-sm" @click.stop="abrirModalCriarProjeto(okr)">
                        <i class="fas fa-plus"></i>
                      </button>
                    </el-tooltip>
                  </div>
                </div>

                <div v-if="okr.listaProjeto && okr.listaProjeto.length > 0" class="accordion" :id="'accordionProj' + okr.idokr">
                  <div id="accordProjeto" class="card shadow-none mb-1 projeto-item-aberto" style="border: 1px solid #e9ecef; border-radius: 10px;" v-for="p in okr.listaProjeto" :key="p.idprojeto">
                    <div class="card-header p-2 bg-light" :id="'headingProj' + p.idprojeto" style="cursor: pointer;"
                      @click="toggleProjeto(okr.idokr, p.idprojeto)"
                         data-toggle="collapse" :data-target="'#collapseProj' + p.idprojeto" aria-expanded="false" :aria-controls="'collapseProj' + p.idprojeto">
                      
                      <!-- PROJETO HEADER -->
                      <div class="row align-items-center m-0 projeto-header">
                        <div class="col-md-6">
                          <i class="far fa-calendar-check text-secondary mr-2"></i> {{ p.codigoNome }}
                        </div>
                        <div class="col-md-1 text-center">
                          <span v-for="resp in p.listaResponsavel" :key="resp.idusuario" style="margin-left: -10px;">
                            <el-tooltip :content="resp.nome" placement="top">
                              <img :src="resp.avatar" :title="resp.nome" width="27" class="rounded-circle border border-white">
                            </el-tooltip>
                          </span>
                        </div>
                        <div class="col-md-2 text-center">
                          <span :class="corSituacaoProjetoTexto(p.situacao)"> {{ p.situacaoDescricao }}</span>
                        </div>
                        <div class="col-md-2 small text-muted text-center">
                          {{ p.dataInicio }} a {{ p.dataFim }}
                        </div>
                        <div class="col-md-1 text-center" style="margin-left: -22px;">
                          <el-tooltip content="Visualizar Projeto" placement="top">
                            <i class="fas fa-eye text-secondary mr-2" style="cursor:pointer;" @click.stop="abrirModalVisualizarProjeto(p)"></i>
                          </el-tooltip>
                          <template v-if="podeAdicionarAtividade(okr, p)">
                            <el-tooltip content="Adicionar Atividade" placement="top">
                              <i class="fas fa-calendar-plus text-primary mr-2" style="cursor:pointer;" @click.stop="abrirModalCriarAtividade(okr, p)"></i>
                            </el-tooltip>
                          </template>
                          <el-tooltip content="Desvincular Projeto" placement="top" v-if="podeGerenciarProjeto(okr)">
                            <i class="fas fa-unlink text-danger" style="cursor:pointer;" @click.stop="desvincularprojeto(okr, p)"></i>
                          </el-tooltip>
                        </div>
                      </div>
                    </div>
                    
                    <div :id="'collapseProj' + p.idprojeto" class="collapse" :aria-labelledby="'headingProj' + p.idprojeto" :data-parent="'#accordionProj' + okr.idokr">
                      <div class="card-body p-2 bg-white">
                        
                        <div v-if="!p.listaAtividade || p.listaAtividade.length === 0" class="text-muted small ml-3">
                          Nenhuma atividade encontrada.
                        </div>

                        <!-- ACCORDION ATIVIDADES -->
                        <div class="accordion" :id="'accordionAtiv' + p.idprojeto" v-if="p.listaAtividade && p.listaAtividade.length > 0">
                          <div class="card shadow-none border-0 mb-1" v-for="a in p.listaAtividade" :key="a.idatividade">
                            <div class="card-header p-2" :id="'headingAtiv' + a.idatividade" style="cursor: pointer; background-color: #fcfcfc; border-bottom: 1px solid #f1f1f1;"
                                 data-toggle="collapse" :data-target="'#collapseAtiv' + a.idatividade" aria-expanded="false" :aria-controls="'collapseAtiv' + a.idatividade">
                              
                              <!-- ATIVIDADE HEADER -->
                              <div class="row align-items-center m-0 projeto-header">
                                <div class="col-md-6 pl-3">
                                  <i class="fas fa-calendar-check text-secondary mr-2"></i> {{ a.codigoNome }}
                                </div>
                                <div class="col-md-1 text-center">
                                  <span v-for="resp in a.listaResponsavel" :key="resp.idusuario" style="margin-left: -10px;">
                                    <el-tooltip :content="resp.nome" placement="top">
                                      <img :src="resp.avatar" :title="resp.nome" width="24" class="rounded-circle border border-white">
                                    </el-tooltip>
                                  </span>
                                </div>
                                <div class="col-md-2 text-center">
                                  <span :class="corSituacaoAtividadeTexto(a.situacao)"> {{ a.situacaoDescricao }}</span>
                                </div>
                                <div class="col-md-2 small text-muted text-center">
                                  {{ a.dataInicio }} a {{ a.dataFim }}
                                </div>
                                <div class="col-md-1 text-center" style="margin-left: -12px;">
                                  <el-tooltip content="Visualizar Atividade" placement="top">
                                    <i class="fas fa-eye text-secondary" style="cursor:pointer;" @click.stop="abrirModalVisualizarAtividade(a)"></i>
                                  </el-tooltip>
                                </div>
                              </div>
                            </div>
                            
                            <div :id="'collapseAtiv' + a.idatividade" class="collapse" :aria-labelledby="'headingAtiv' + a.idatividade" :data-parent="'#accordionAtiv' + p.idprojeto">
                              <div class="card-body p-1 pl-4">
                                
                                <div v-if="!a.listaTarefa || a.listaTarefa.length === 0" class="text-muted small ml-3 mt-1 mb-1">
                                  Nenhuma tarefa encontrada.
                                </div>

                                <!-- LISTA DE TAREFAS -->
                                <div class="row align-items-center m-0 border-bottom py-1 projeto-header" v-for="t in a.listaTarefa" :key="t.idtarefa">
                                  <div class="col-md-7 pl-3">
                                    <small><i class="fas fa-tasks text-secondary mr-2"></i> {{ t.codigoNome }}</small>
                                  </div>
                                  <div class="col-md-2 text-center">
                                    <span :class="corSituacaoAtividadeTexto(t.situacao)"> {{ t.situacaoDescricao }}</span>
                                  </div>
                                  <div class="col-md-3 text-muted text-center" style="font-size: 11px;">
                                    {{ t.dataInicio }} a {{ t.dataFim }}
                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="text-muted small ml-3 mb-2">Nenhum projeto vinculado.</div>
              </div>
            </div>
          </div>
          <div v-if="okrsPorTipoFiltrada('GERAL').length === 0" class="p-3 text-center text-muted">
            Nenhum Objetivo Geral.
          </div>
        </div>
      </div>

      <!-- PROJETOS NÃO VINCULADOS -->
      <div class="card mb-2 mt-2">
        <div class="card-header secao-header" @click="accordionNaoVinculados = !accordionNaoVinculados" style="cursor:pointer;">
          <strong>
            <i class="fas fa-unlink mr-2 text-warning"></i>
            Projetos não vinculados <span v-if="!progressProjetosNaoVinculados">({{ listaProjetosNaoVinculados.length }})</span>
            <!--<span v-else class="badge badge-light ml-1"><i class="fas fa-spinner fa-spin"></i></span>-->
          </strong>
          <i :class="accordionNaoVinculados ? 'fas fa-chevron-up float-right' : 'fas fa-chevron-down float-right'"></i>
        </div>

        <div v-show="accordionNaoVinculados">
          <!-- Loading enquanto carrega em background -->
          <div v-if="progressProjetosNaoVinculados" class="p-4 text-center text-muted">
            <i class="fas fa-spinner fa-spin mr-2"></i> Carregando projetos não vinculados...
          </div>

          <!-- Vazio -->
          <div v-else-if="listaProjetosNaoVinculados.length === 0" class="p-3 text-center text-muted">
            <i class="fas fa-check-circle text-success mr-1"></i> Todos os projetos estão vinculados a algum OKR.
          </div>

          <!-- Lista de projetos não vinculados -->
          <div v-else class="accordion" id="accordionNaoVinc">
            <div class="card shadow-none mb-1 projeto-nao-v-item-aberto" style="border: 1px solid #e9ecef; border-radius: 10px; margin: 8px;"
                 v-for="proj in listaProjetosNaoVinculados" :key="proj.idprojeto">

              <!-- HEADER DO PROJETO -->
              <div class="card-header p-2 bg-light" style="cursor:pointer;"
                   data-toggle="collapse" :data-target="'#collapseNVProj' + proj.idprojeto"
                   aria-expanded="false" :aria-controls="'collapseNVProj' + proj.idprojeto">
                <div class="row align-items-center m-0 projeto-header">
                  <div class="col-md-6">
                    <i class="far fa-calendar-check text-secondary mr-2"></i> {{ proj.codigoNome }}
                  </div>
                  <div class="col-md-1 text-center">
                    <span v-for="resp in proj.listaResponsavel" :key="resp.idusuario" style="margin-left: -10px;">
                      <el-tooltip :content="resp.nome" placement="top">
                        <img :src="resp.avatar" :title="resp.nome" width="27" class="rounded-circle border border-white">
                      </el-tooltip>
                    </span>
                  </div>
                  <div class="col-md-2 text-center">
                    <span :class="corSituacaoProjetoTexto(proj.situacao)">{{ proj.situacaoDescricao }}</span>
                  </div>
                  <div class="col-md-2 small text-muted text-center">
                    {{ proj.dataInicio }} a {{ proj.dataFim }}
                  </div>
                  <div class="col-md-1 text-center" style="margin-left: -22px;">
                    <el-tooltip content="Visualizar Projeto" placement="top">
                      <i class="fas fa-eye text-secondary mr-2" style="cursor:pointer;" @click.stop="abrirModalVisualizarProjeto(proj)"></i>
                    </el-tooltip>
                    <el-tooltip content="Vincular ao OKR" placement="top">
                      <i class="fas fa-link text-success" style="cursor:pointer;" @click.stop="abrirModalVincularAoOkr(proj)"></i>
                    </el-tooltip>
                  </div>
                </div>
              </div>

              <!-- ATIVIDADES DO PROJETO -->
              <div :id="'collapseNVProj' + proj.idprojeto" class="collapse"
                   :aria-labelledby="'headingNVProj' + proj.idprojeto" data-parent="#accordionNaoVinc">
                <div class="card-body p-2 bg-white">

                  <div v-if="!proj.listaAtividade || proj.listaAtividade.length === 0" class="text-muted small ml-3">
                    Nenhuma atividade encontrada.
                  </div>

                  <div class="accordion" :id="'accordionNVAtiv' + proj.idprojeto" v-if="proj.listaAtividade && proj.listaAtividade.length > 0">
                    <div class="card shadow-none border-0 mb-1" v-for="a in proj.listaAtividade" :key="a.idatividade">
                      <div class="card-header p-2" :id="'headingNVAtiv' + a.idatividade"
                           style="cursor:pointer; background-color:#fcfcfc; border-bottom:1px solid #f1f1f1;"
                           data-toggle="collapse" :data-target="'#collapseNVAtiv' + a.idatividade"
                           aria-expanded="false" :aria-controls="'collapseNVAtiv' + a.idatividade">

                        <div class="row align-items-center m-0 projeto-header">
                          <div class="col-md-6 pl-3">
                            <i class="fas fa-calendar-check text-secondary mr-2"></i> {{ a.codigoNome }}
                          </div>
                          <div class="col-md-1 text-center">
                            <span v-for="resp in a.listaResponsavel" :key="resp.idusuario" style="margin-left: -10px;">
                              <el-tooltip :content="resp.nome" placement="top">
                                <img :src="resp.avatar" :title="resp.nome" width="24" class="rounded-circle border border-white">
                              </el-tooltip>
                            </span>
                          </div>
                          <div class="col-md-2 text-center">
                            <span :class="corSituacaoAtividadeTexto(a.situacao)">{{ a.situacaoDescricao }}</span>
                          </div>
                          <div class="col-md-2 small text-muted text-center">
                            {{ a.dataInicio }} a {{ a.dataFim }}
                          </div>
                          <div class="col-md-1 text-center">
                            <el-tooltip content="Visualizar Atividade" placement="top">
                              <i class="fas fa-eye text-secondary" style="cursor:pointer;" @click.stop="abrirModalVisualizarAtividade(a)"></i>
                            </el-tooltip>
                          </div>
                        </div>
                      </div>

                      <!-- TAREFAS -->
                      <div :id="'collapseNVAtiv' + a.idatividade" class="collapse"
                           :aria-labelledby="'headingNVAtiv' + a.idatividade" :data-parent="'#accordionNVAtiv' + proj.idprojeto">
                        <div class="card-body p-1 pl-4">
                          <div v-if="!a.listaTarefa || a.listaTarefa.length === 0" class="text-muted small ml-3 mt-1 mb-1">
                            Nenhuma tarefa encontrada.
                          </div>
                          <div class="row align-items-center m-0 border-bottom py-1 projeto-header"
                               v-for="t in a.listaTarefa" :key="t.idtarefa">
                            <div class="col-md-7 pl-3">
                              <small><i class="fas fa-tasks text-secondary mr-2"></i> {{ t.codigoNome }}</small>
                            </div>
                            <div class="col-md-2 text-center">
                              <span :class="corSituacaoAtividadeTexto(t.situacao)">{{ t.situacaoDescricao }}</span>
                            </div>
                            <div class="col-md-3 text-muted text-center" style="font-size:11px;">
                              {{ t.dataInicio }} a {{ t.dataFim }}
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- MODAL INCLUIR NOVO INDICADOR -->
    <modal :show.sync="modals.modalNovoIndicador" size="lg" modal-classes="modal-dialog-scrollable">
      <form class="ml-3 mt-3 mr-3 mb-3">
        <h4 class="text-center">Incluir novo indicador</h4>
        <p class="text-center text-muted mb-2">{{ okrNovoIndicador.descricao }}</p>

        <div class="row">
          <div class="col-md-12">
            <label for="novoIndDescricao">
              Título
              <el-tooltip content="Campo obrigatório" placement="top">
                <i style="font-size:12px" class="fas fa-exclamation-circle text-info ml-1"></i>
              </el-tooltip>
            </label>
            <input id="novoIndDescricao" ref="novoIndDescricaoInput" type="text" class="form-control mb-2" v-model="indicadorNovo.descricao" maxlength="300" placeholder="Descreva o resultado-chave"/>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <label for="novoIndBaseline">
              Baseline <small class="text-muted">(valor inicial)</small>
              <el-tooltip content="Campo obrigatório" placement="top">
                <i style="font-size:12px" class="fas fa-exclamation-circle text-info ml-1"></i>
              </el-tooltip>
            </label>
            <input id="novoIndBaseline" type="number" step="any" class="form-control mb-2" v-model="indicadorNovo.baseline" placeholder="0"
              onkeypress="return event.charCode >= 48 && event.charCode <= 57 || event.charCode == 46 || event.charCode == 45"/>
          </div>
          <div class="col-md-6">
            <label for="novoIndMeta">
              Meta
              <el-tooltip content="Campo obrigatório" placement="top">
                <i style="font-size:12px" class="fas fa-exclamation-circle text-info ml-1"></i>
              </el-tooltip>
            </label>
            <input id="novoIndMeta" type="number" step="any" class="form-control mb-2" v-model="indicadorNovo.meta" placeholder="100"
              onkeypress="return event.charCode >= 48 && event.charCode <= 57 || event.charCode == 46 || event.charCode == 45"/>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <label for="novoIndTipo">
              Tipo
              <el-tooltip content="Campo obrigatório" placement="top">
                <i style="font-size:12px" class="fas fa-exclamation-circle text-info ml-1"></i>
              </el-tooltip>
            </label>
            <select id="novoIndTipo" class="form-control mb-2" v-model="indicadorNovo.tipoIndicador">
              <option value="">Selecione</option>
              <option v-for="t in listaTipoIndicador" :key="t.codigo" :value="t.codigo">{{t.descricao}}</option>
            </select>
          </div>
          <div class="col-md-6">
            <label for="novoIndSentido">
              Sentido
              <el-tooltip content="Indica se atingir um valor maior ou menor significa progresso. Campo obrigatório" placement="top">
                <i style="font-size:12px" class="fas fa-exclamation-circle text-info ml-1"></i>
              </el-tooltip>
            </label>
            <select id="novoIndSentido" class="form-control mb-2" v-model="indicadorNovo.sentido">
              <option value="">Selecione</option>
              <option v-for="s in listaSentidoIndicador" :key="s.codigo" :value="s.codigo">{{s.descricao}}</option>
            </select>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <label for="novoIndFonte">Fonte de Verificação</label>
            <input id="novoIndFonte" type="text" class="form-control mb-2" v-model="indicadorNovo.fonte" maxlength="2000" placeholder="Ex: Planilha de monitoramento, Sinan. Ano-base..."/>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <label for="novoIndFormaCalculo">Forma de Cálculo</label>
            <textarea id="novoIndFormaCalculo" class="form-control mb-2" rows="3" maxlength="4000"
              v-model="indicadorNovo.formaCalculo" placeholder="Descreva como o indicador é calculado (opcional)"></textarea>
            <div class="text-right">
              <small class="text-muted">{{ (indicadorNovo.formaCalculo || '').length }}/4000</small>
            </div>
          </div>
        </div>

        <div class="row mt-2 mb-3">
          <div class="col-md-12 d-flex align-items-center">
            <label class="mb-0 mr-3">Situação inicial do KR</label>
            <div class="custom-control custom-switch">
              <input type="checkbox" class="custom-control-input" id="novoIndicadorSituacaoSwitch"
                v-model="indicadorNovo.situacao"
                true-value="EM_ANDAMENTO" false-value="NAO_INICIADO" style="cursor: pointer;">
              <label class="custom-control-label font-weight-bold" for="novoIndicadorSituacaoSwitch" style="cursor: pointer;">
                {{ indicadorNovo.situacao === 'EM_ANDAMENTO' ? 'Em andamento' : 'Não iniciado' }}
              </label>
            </div>
          </div>
        </div>

        <div class="col-md-12 text-center mt-3">
          <button type="button" class="btn btn-success mr-2" @click="confirmarNovoIndicador()">
            <i class="fas fa-check mr-1"></i> Confirmar
          </button>
          <button type="button" class="btn btn-danger" @click="fecharModalNovoIndicador()">Cancelar</button>
        </div>
      </form>
    </modal>

    <!-- MODAL ATUALIZAR INDICADOR -->
    <modal :show.sync="modals.modalAtualizar" size="lg" modal-classes="modal-dialog-scrollable">
      <form class="ml-3 mt-3 mr-3 mb-3">
        <h4 class="text-center">Atualizar Indicador</h4>
        <p class="text-center text-muted mb-1">{{ indicadorAtualizar.descricao }}</p>
        <p class="text-center mb-3">
          <span class="ml-2 font-weight-bold" :class="corSituacaoKrTexto(indicadorAtualizar.situacao)">{{ indicadorAtualizar.situacaoDescricao }}</span>
        </p>

        <div class="row mt-2">
          <div class="col-md-6">
            <label>Valor Atual
              <el-tooltip content="Campo obrigatório" placement="top">
                <i style="font-size:12px" class="fas fa-exclamation-circle text-info ml-1"></i>
              </el-tooltip>
            </label>
            <input type="number" step="any" class="form-control" v-model="indicadorAtualizar.atual" placeholder="Informe o valor atual"/>
          </div>
          <div class="col-md-6">
            <label>Confiança: <strong>{{ indicadorAtualizar.confianca }}/10</strong></label>
            <input type="range" class="form-control-range" min="1" max="10"
              v-model="indicadorAtualizar.confianca"/>
            <div class="d-flex justify-content-between">
              <small class="text-danger">1 — Baixa</small>
              <small class="text-success">10 — Alta</small>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col">
            <label>Observação</label>
            <textarea class="form-control" rows="2" v-model="indicadorAtualizar.observacao"
              maxlength="200"
              placeholder="Observações sobre esta atualização (opcional)">
            </textarea>
            <div class="text-right mt-1">
              <small class="text-muted">{{ indicadorAtualizar.observacao ? indicadorAtualizar.observacao.length : 0 }}/200</small>
            </div>
          </div>
        </div>

        <hr class="mt--1">

        <div class="row">
          <div class="col-md-6">
            <label for="indBaseline">
              Baseline <small class="text-muted">(valor inicial)</small>
              <el-tooltip content="Campo obrigatório" placement="top">
                <i style="font-size:12px" class="fas fa-exclamation-circle text-info ml-1"></i>
              </el-tooltip>
            </label>
            <input id="indBaseline" type="number" step="any" :class="isAdmin() ? 'form-control mb-2' : 'form-control mb-2 readonly-field'" v-model="indicadorAtualizar.baseline" placeholder="0" :readonly="!isAdmin()"
              onkeypress="return event.charCode >= 48 && event.charCode <= 57 || event.charCode == 46 || event.charCode == 45"/>
          </div>
          <div class="col-md-6">
            <label for="indMeta">
              Meta
              <el-tooltip content="Campo obrigatório" placement="top">
                <i style="font-size:12px" class="fas fa-exclamation-circle text-info ml-1"></i>
              </el-tooltip>
            </label>
            <input id="indMeta" type="number" step="any" :class="isAdmin() ? 'form-control mb-2' : 'form-control mb-2 readonly-field'" v-model="indicadorAtualizar.meta" placeholder="100" :readonly="!isAdmin()"
              onkeypress="return event.charCode >= 48 && event.charCode <= 57 || event.charCode == 46 || event.charCode == 45"/>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <label for="indTipo">
              Tipo
              <el-tooltip content="Campo obrigatório" placement="top">
                <i style="font-size:12px" class="fas fa-exclamation-circle text-info ml-1"></i>
              </el-tooltip>
            </label>
            <select id="indTipo" :class="isAdmin() ? 'form-control mb-2' : 'form-control mb-2 readonly-field'" v-model="indicadorAtualizar.tipoIndicador" :disabled="!isAdmin()">
              <option value="">Selecione</option>
              <option v-for="t in listaTipoIndicador" :key="t.codigo" :value="t.codigo">{{t.descricao}}</option>
            </select>
          </div>
          <div class="col-md-6">
            <label for="indSentido">
              Sentido
              <el-tooltip content="Indica se atingir um valor maior ou menor significa progresso. Campo obrigatório" placement="top">
                <i style="font-size:12px" class="fas fa-exclamation-circle text-info ml-1"></i>
              </el-tooltip>
            </label>
            <select id="indSentido" :class="isAdmin() ? 'form-control mb-2' : 'form-control mb-2 readonly-field'" v-model="indicadorAtualizar.sentido" :disabled="!isAdmin()">
              <option value="">Selecione</option>
              <option v-for="s in listaSentidoIndicador" :key="s.codigo" :value="s.codigo">{{s.descricao}}</option>
            </select>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <label for="indFonte">Fonte de Verificação</label>
            <input id="indFonte" type="text" class="form-control mb-2" v-model="indicadorAtualizar.fonte" maxlength="2000" placeholder="Ex: Planilha de monitoramento, Sinan. Ano-base..."/>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <label for="atualizarIndFormaCalculo">Forma de Cálculo</label>
            <textarea id="atualizarIndFormaCalculo" class="form-control mb-2" rows="3" maxlength="4000"
              v-model="indicadorAtualizar.formaCalculo" placeholder="Descreva como o indicador é calculado (opcional)"></textarea>
            <div class="text-right">
              <small class="text-muted">{{ (indicadorAtualizar.formaCalculo || '').length }}/4000</small>
            </div>
          </div>
        </div>

        <div class="col-md-12 text-center mt-3">
          <button type="button" class="btn btn-success mr-2" @click="confirmarAtualizar()">
            <i class="fas fa-check mr-1"></i> Atualizar
          </button>
          <button type="button" class="btn btn-danger" @click="modals.modalAtualizar = false">Cancelar</button>
        </div>
      </form>
    </modal>

    <!-- MODAL VINCULAR PROJETO -->
    <modal :show.sync="modals.modalVincularProjeto" size="lg">
      <form class="ml-3 mt-3 mr-3 mb-3">
        <h4 class="text-center">Vincular Projeto</h4>
        <p class="text-center text-muted">{{ okrVincularProjeto.descricao }}</p>
        <div class="row">
          <div class="col input-group">
            <div class="input-group-prepend mb-2">
              <span class="input-group-text"><i class="fas fa-search"></i></span>
            </div>
            <input type="text" ref="addProjNomeInput" class="form-control mb-2"
              v-model="addProjNome" :disabled="progressVincularProjeto"
              placeholder="Pesquisar por nome ou código" @keyup="pesquisarProjetoVincular()"/>
          </div>
        </div>
        <div style="height:250px; border:1px dashed #c0c0c0; overflow:auto">
          <div v-if="addProjNome.length < 3 && !progressVincularProjeto" class="text-center text-muted p-3">
            <i class="fas fa-search mr-1"></i> Digite ao menos 3 caracteres para pesquisar.
          </div>
          <div v-else-if="progressVincularProjeto" class="text-center text-muted p-3">
            <i class="fas fa-spinner fa-spin mr-1"></i> Pesquisando...
          </div>
          <div v-else-if="listaAddProjVincular.length === 0 && addProjNome.length >= 3" class="text-center text-muted p-3">
            Nenhum projeto encontrado.
          </div>
          <div class="listaGT" v-for="proj in listaAddProjVincular" :key="proj.idprojeto">
            <div class="gtInfo" @click="confirmarVincularProjeto(proj)" style="align-items: flex-start;">
              <span style="flex: 1; word-break: break-word; white-space: normal;">{{ proj.codigo }} - {{ proj.titulo }}</span>
              <i class="fas fa-plus text-muted opcao mr-3 mt-1" style="flex-shrink: 0;"></i>
            </div>
          </div>
        </div>
        <br class="clear"/>
        <div class="col-md-12 text-center mt-3">
          <button type="button" class="btn btn-secondary ml-4" @click="fecharModalVincularProjeto()">Fechar</button>
        </div>
      </form>
    </modal>

    <!-- MODAL VINCULAR AO OKR (projetos não vinculados) -->
    <modal :show.sync="modals.modalVincularAoOkr" size="lg">
      <form class="ml-3 mt-3 mr-3 mb-3">
        <h4 class="text-center">Vincular ao OKR</h4>
        <p class="text-center text-muted">{{ projetoVincularAoOkr ? projetoVincularAoOkr.codigoNome : '' }}</p>
        <div class="row">
          <div class="col input-group">
            <div class="input-group-prepend mb-2">
              <span class="input-group-text"><i class="fas fa-search"></i></span>
            </div>
            <input type="text" class="form-control mb-2"
              v-model="filtroOkrVinculo"
              placeholder="Filtrar OKRs por descrição"/>
          </div>
        </div>
        <div style="height:280px; border:1px dashed #c0c0c0; overflow:auto">
          <div v-if="okrsParaVincular.length === 0" class="text-center text-muted p-3">
            <i class="fas fa-info-circle mr-1"></i>
            Nenhum OKR disponível para este projeto
            <span v-if="filtroOkrVinculo">(filtro ativo)</span>.
          </div>
          <div class="listaGT" v-for="okr in okrsParaVincular" :key="okr.idokr">
            <div class="gtInfo" @click="confirmarVincularProjetoAoOkr(okr)" style="align-items: flex-start;">
              <span style="flex: 1; word-break: break-word; white-space: normal;">
                <strong>{{ addMascaraCodigo("OKR", okr.idokr) }}</strong> — {{ okr.descricao }}
                <small class="text-muted ml-1">({{ okr.tipoDescricao }})</small>
              </span>
              <i class="fas fa-link text-muted opcao mr-3 mt-1" style="flex-shrink: 0;"></i>
            </div>
          </div>
        </div>
        <br class="clear"/>
        <div class="col-md-12 text-center mt-3">
          <button type="button" class="btn btn-secondary ml-4" @click="fecharModalVincularAoOkr()">Fechar</button>
        </div>
      </form>
    </modal>

    <!-- MODAL FONTE DE VERIFICAÇÃO -->
    <modal :show.sync="modals.modalFonte">
      <div class="ml-3 mt-2 mr-3 mb-3">
        <h5 class="text-center mb-1"><i class="fas fa-link mr-2 text-muted"></i>Fonte de Verificação</h5>
        <p class="text-center text-muted small mb-3">{{ indicadorFonte.descricao }}</p>
        <hr/>
        <p class="text-justify mt-2">{{ indicadorFonte.fonte || 'Nenhuma fonte informada.' }}</p>
        <div class="text-center mt-3">
          <button type="button" class="btn btn-secondary" @click="modals.modalFonte = false">Fechar</button>
        </div>
      </div>
    </modal>

    <!-- MODAL CRIAR PROJETO -->
    <modal :show.sync="modals.modalCriarProjeto" size="lg">
      <h5 class="text-center mt-1 mb-3">Cadastro de novo projeto</h5>
      <ProjetoFormulario
        v-if="modals.modalCriarProjeto"
        :modo="'modal'"
        @cancel="fecharModalCriarProjeto()"
        @save="projetoCriado($event)"
      />
    </modal>

    <!-- MODAL CRIAR ATIVIDADE -->
    <modal :show.sync="modals.modalCriarAtividade" size="lg">
      <div class="text-right iconeFecharModalCadastro">
        <span @click="fecharModalCriarAtividade()" class="pull-right clickable close-icon" data-effect="fadeOut"><i class="fa fa-times"></i></span>
      </div>
      <h5 class="text-center mt-1 mb-3">Cadastro de nova atividade</h5>
      <AtividadeFormulario
        v-if="modals.modalCriarAtividade"
        :projetoSelecao="projetoParaCriarAtividade"
        @fechar-cadastro="fecharModalCriarAtividade()"
        @atualizar-lista="atividadeCriada()"
      />
    </modal>

    <!-- MODAL VISUALIZAR PROJETO -->
    <modal :show.sync="modals.modalVisualizarProjeto" size="xl">
      <div class="text-right iconeFecharModal">
        <span @click="fecharModalVisualizarProjeto()" class="pull-right clickable close-icon" data-effect="fadeOut"><i class="fa fa-times"></i></span>
      </div>
      <Projeto v-if="modals.modalVisualizarProjeto"
        @fechar-projeto="fecharModalVisualizarProjeto"
        @abrir-atividade="abrirModalVisualizarAtividade"
        :projetoSelecionado="projetoParaVisualizar"
        :carregandoExterno="carregandoProjetoVisualizacao" />
    </modal>

    <!-- MODAL VISUALIZAR ATIVIDADE -->
    <modal :show.sync="modals.modalVisualizarAtividade" size="xl">
      <div class="text-right iconeFecharModal">
        <span @click="fecharModalVisualizarAtividade()" class="pull-right clickable close-icon" data-effect="fadeOut"><i class="fa fa-times"></i></span>
      </div>
      <Atividade v-if="modals.modalVisualizarAtividade"
        @fechar-atividade="fecharModalVisualizarAtividade"
        @abrir-projeto="abrirModalVisualizarProjeto"
        :atividadeSelecionada="atividadeParaVisualizar" />
    </modal>

  </div>
</template>

<script>
import Linha from "../components/graficos/Linha.vue";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import ProjetoFormulario from "../components/ProjetoFormulario.vue";
import AtividadeFormulario from "../components/AtividadeFormulario.vue";
import Projeto from "../components/Projeto.vue";
import Atividade from "../components/Atividade.vue";

export default {
  components: {
    Linha,
    flatPicker,
    ProjetoFormulario,
    AtividadeFormulario,
    Projeto,
    Atividade,
  },
  created() {
    this.carregarFiltros();
    this.carregarTela();
  },
  data() {
    return {
      userId: Number(localStorage.getItem("idusuario")),
      perfil: localStorage.getItem("pnome"),
      progress: false,
      listaOkr: [],
      listaOkrFiltrada: [],
      listaTipo: [],
      listaSituacao: [],
      listaTipoIndicador: [],
      listaSentidoIndicador: [],
      
      listaDepartamentoFiltro: [],
      listaCoordenacaoFiltro: [],
      listaCoordenacaoFiltroFiltrada: [],
      listaGtFiltro: [],
      listaGtFiltroFiltrada: [],
      listaResponsavelFiltro: [],
      carregandoResponsaveis: false,
      
      filtro: { departamento: "", coordenacao: "", gt: "", responsavel: "", dataInicio: this.filtroDataInicioPadrao(), dataFim: this.filtroDataFimPadrao(), situacao: "", descricao: "" },
      okrsAbertos: [],
      projetoAbertoPorOkr: {},
      accordionFiltros:     false,
      accordionEstrategico: true,
      accordionGeral:       true,
      accordionNaoVinculados: false,
      modals: { modalNovoIndicador: false, modalAtualizar: false, modalVincularProjeto: false, modalFonte: false, modalCriarProjeto: false, modalCriarAtividade: false, modalVisualizarProjeto: false, modalVisualizarAtividade: false, modalVincularAoOkr: false },
      okrNovoIndicador: { idokr: null, descricao: "" },
      indicadorNovo: { descricao: "", baseline: null, meta: null, tipoIndicador: "", sentido: "", fonte: "", formaCalculo: "", situacao: "NAO_INICIADO" },
      okrParaCriarProjeto: null,
      projetoParaCriarAtividade: null,
      projetoParaVisualizar: null,
      atividadeParaVisualizar: null,
      carregandoProjetoVisualizacao: false,
      cacheProjetoDetalhe: {},
      okrVincularProjeto: { idokr: null, descricao: '' },
      indicadorFonte: { descricao: '', fonte: '' },
      addProjNome: '',
      listaAddProjVincular: [],
      progressVincularProjeto: false,
      timeoutProj: null,
      // Projetos não vinculados
      listaProjetosNaoVinculados: [],
      progressProjetosNaoVinculados: true,
      projetoVincularAoOkr: null,
      filtroOkrVinculo: '',
      indicadorAtualizar: {
        idokr: null, idindicador: null, descricao: "", atual: null, confianca: 5, observacao: "",
        baseline: null, meta: null, tipoIndicador: "", sentido: "", fonte: "", formaCalculo: "", situacao: "", situacaoDescricao: ""
      },
      chartVersion: 0,
      optionsLinha: {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        scales: {
          xAxes: [{ ticks: { display: false } }],
          yAxes: [
            {
              id: 'progressao',
              position: 'left',
              ticks: {
                fontColor: 'rgb(23, 162, 184)',
                beginAtZero: true,
              },
              scaleLabel: { display: false }
            },
            {
              id: 'confianca',
              position: 'right',
              gridLines: { drawOnChartArea: false },
              ticks: {
                fontColor: '#28a745',
                min: 0,
                max: 10,
                stepSize: 1,
              },
              scaleLabel: { display: false }
            }
          ]
        },
      },
    };
  },
  computed: {
    /**
     * OKRs elegíveis para vincular o projeto selecionado.
     * Regras:
     *  1. OKR não cancelada
     *  2. GT do OKR está na listaIdsGt do projeto (relação N:N Projeto-GT)
     *  3. Filtra pelo texto digitado (case-insensitive)
     */
    okrsParaVincular() {
      if (!this.projetoVincularAoOkr) return [];
      const idsGt = this.projetoVincularAoOkr.listaIdsGt || [];
      const filtro = (this.filtroOkrVinculo || '').toLowerCase();
      return this.listaOkr.filter(okr => {
        if (okr.situacao === 'CANCELADO') return false;
        if (idsGt.length > 0 && okr.grupoTrabalho && !idsGt.includes(okr.grupoTrabalho.idgt)) return false;
        if (filtro && !okr.descricao.toLowerCase().includes(filtro)) return false;
        return true;
      });
    },
  },
  methods: {
    filtroDataInicioPadrao() {
      const ano = new Date().getFullYear();
      return `01/01/${ano}`;
    },
    filtroDataFimPadrao() {
      const ano = new Date().getFullYear();
      return `31/12/${ano}`;
    },
    carregarTela() {
      this.progress = true;
      Promise.all([
        this.$clubApi.get("/enum/tipoOkr"),
        this.$clubApi.get("/enum/situacaoOkr"),
        this.$clubApi.get("/enum/tipoIndicadorOkr"),
        this.$clubApi.get("/enum/sentidoIndicador"),
        this.$clubApi.get("/okr"),
      ]).then(([rTipo, rSit, rTipoInd, rSentido, rOkr]) => {
        this.listaTipo              = rTipo.data.object;
        this.listaSituacao          = rSit.data.object;
        this.listaTipoIndicador     = rTipoInd.data.object || [];
        this.listaSentidoIndicador  = rSentido.data.object || [];
        this.listaOkr      = rOkr.data.object || [];
        this.chartVersion++;
        this.aplicarFiltro();
        // Carrega projetos não vinculados em background (não bloqueia loading principal)
        this.carregarProjetosNaoVinculados();
      }).catch(() => {
        this.$toastr.error("Erro ao carregar dados.");
      }).finally(() => { this.progress = false; });
    },
    aplicarFiltro() {
      let lista = this.listaOkr;
      
      if (this.filtro.departamento) {
        lista = lista.filter(o => {
          if (!o.grupoTrabalho || !o.grupoTrabalho.coordenacao) return false;
          let cId = typeof o.grupoTrabalho.coordenacao === 'object' ? o.grupoTrabalho.coordenacao.idcoordenacao : o.grupoTrabalho.coordenacao;
          let cObj = this.listaCoordenacaoFiltro.find(c => c.idcoordenacao === cId);
          if (cObj && cObj.departamento) {
            let dId = typeof cObj.departamento === 'object' ? cObj.departamento.iddepartamento : cObj.departamento;
            return dId === this.filtro.departamento;
          }
          return false;
        });
      }
      if (this.filtro.coordenacao) {
        lista = lista.filter(o => {
          if (!o.grupoTrabalho || !o.grupoTrabalho.coordenacao) return false;
          let cId = typeof o.grupoTrabalho.coordenacao === 'object' ? o.grupoTrabalho.coordenacao.idcoordenacao : o.grupoTrabalho.coordenacao;
          return cId === this.filtro.coordenacao;
        });
      }
      if (this.filtro.gt) {
        lista = lista.filter(o => {
          if (!o.grupoTrabalho) return false;
          let gtId = typeof o.grupoTrabalho === 'object' ? o.grupoTrabalho.idgt : o.grupoTrabalho;
          return gtId === this.filtro.gt;
        });
      }
      if (this.filtro.responsavel) {
        lista = lista.filter(o => o.listaResponsavel && o.listaResponsavel.some(r => r.idusuario === this.filtro.responsavel));
      }
      if (this.filtro.situacao) {
        lista = lista.filter(o => o.situacao === this.filtro.situacao);
      }
      const parseDate = (d) => {
        if (!d) return 0;
        let p = d.split(d.includes('-') ? '-' : '/');
        // Se a data já estiver em yyyy-mm-dd
        if (p[0].length === 4) return parseInt(p[0] + p[1] + p[2], 10);
        // Se estiver em dd/mm/yyyy
        return parseInt(p[2] + p[1] + p[0], 10);
      };

      if (this.filtro.dataInicio) {
        let filtroIni = parseDate(this.filtro.dataInicio);
        lista = lista.filter(o => o.dataFim && parseDate(o.dataFim) >= filtroIni);
      }
      if (this.filtro.dataFim) {
        let filtroFim = parseDate(this.filtro.dataFim);
        lista = lista.filter(o => o.dataInicio && parseDate(o.dataInicio) <= filtroFim);
      }
      if (this.filtro.descricao) {
        let busca = this.filtro.descricao.toUpperCase().trim();
        lista = lista.filter(o => this.okrMatchBusca(o, busca));
      }
      
      this.listaOkrFiltrada = lista;
    },
    limparFiltro() {
      this.filtro = { departamento: "", coordenacao: "", gt: "", responsavel: "", dataInicio: this.filtroDataInicioPadrao(), dataFim: this.filtroDataFimPadrao(), situacao: "", descricao: "" };
      if (this.perfil === 'ADMIN' || this.perfil === 'DIRETOR') {
        this.listaCoordenacaoFiltroFiltrada = this.listaCoordenacaoFiltro;
        this.listaGtFiltroFiltrada = this.listaGtFiltro;
        this.carregarResponsaveis(this.listaGtFiltro);
      } else {
        this.carregarResponsaveis(this.listaGtFiltro);
      }
      this.aplicarFiltro();
    },
    changeDepartamento() {
      this.filtro.coordenacao = "";
      this.filtro.gt = "";
      this.filtro.responsavel = "";
      
      if (this.filtro.departamento) {
        this.listaCoordenacaoFiltroFiltrada = this.listaCoordenacaoFiltro.filter(c => c.departamento && c.departamento.iddepartamento === this.filtro.departamento);
      } else {
        this.listaCoordenacaoFiltroFiltrada = this.listaCoordenacaoFiltro;
      }
      
      this.changeCoordenacao(true);
      this.aplicarFiltro();
    },
    changeCoordenacao(skipResp = false) {
      this.filtro.gt = "";
      this.filtro.responsavel = "";
      
      if (!this.filtro.departamento && !this.filtro.coordenacao) {
        this.listaGtFiltroFiltrada = this.listaGtFiltro;
      } else {
        let coordsAtuais = this.filtro.coordenacao 
            ? [this.filtro.coordenacao] 
            : this.listaCoordenacaoFiltroFiltrada.map(c => c.idcoordenacao);
            
        this.listaGtFiltroFiltrada = this.listaGtFiltro.filter(g => {
          let cId = g.coordenacao && typeof g.coordenacao === 'object' ? g.coordenacao.idcoordenacao : g.coordenacao;
          return cId && coordsAtuais.includes(cId);
        });
      }
      
      if (!skipResp) {
        this.carregarResponsaveis(this.listaGtFiltroFiltrada);
        this.aplicarFiltro();
      } else {
        this.carregarResponsaveis(this.listaGtFiltroFiltrada);
      }
    },
    changeGt() {
      this.filtro.responsavel = "";
      if (this.filtro.gt) {
        this.carregarResponsaveis([{ idgt: this.filtro.gt }]);
      } else {
        this.carregarResponsaveis(this.listaGtFiltroFiltrada);
      }
      this.aplicarFiltro();
    },
    carregarResponsaveis(listaGts) {
      if (!listaGts || listaGts.length === 0) {
        this.listaResponsavelFiltro = [];
        return;
      }
      this.listaResponsavelFiltro = [];
      this.carregandoResponsaveis = true;
      let payload = { grupoTrabalho: listaGts.map(g => ({ idgt: g.idgt })) };
      this.$clubApi.post("/user/nome/", payload).then(res => {
        this.listaResponsavelFiltro = res.data.object || [];
      }).catch(() => {
        this.listaResponsavelFiltro = [];
      }).finally(() => {
        this.carregandoResponsaveis = false;
      });
    },
    carregarFiltros() {
      if (this.perfil === 'ADMIN' || this.perfil === 'DIRETOR') {
        Promise.all([
          this.$clubApi.get("/estrutura/dpto/ativo"),
          this.$clubApi.get("/estrutura/coord/ativo"),
          this.$clubApi.get("/estrutura/gt/ativo")
        ]).then(([rDpto, rCoord, rGt]) => {
          this.listaDepartamentoFiltro = rDpto.data.object || [];
          this.listaCoordenacaoFiltro = rCoord.data.object || [];
          this.listaGtFiltro = rGt.data.object || [];
          this.listaCoordenacaoFiltroFiltrada = this.listaCoordenacaoFiltro;
          this.listaGtFiltroFiltrada = this.listaGtFiltro;
          this.carregarResponsaveis(this.listaGtFiltro);
        });
      } else if (this.perfil === 'COORDENADOR') {
        this.$clubApi.get("/estrutura/coord/ativo").then(resCoord => {
          let allCoords = resCoord.data.object || [];
          console.log("allCoords", allCoords);
          console.log("this.userId", this.userId);
          let myCoords = allCoords.filter(c => c.listaCoordenador && c.listaCoordenador.some(user => user.idusuario === this.userId));
          console.log("myCoords", myCoords);
          this.$clubApi.get("/estrutura/gt/ativo").then(rGt => {
            let allGt = rGt.data.object || [];
            let myGt = allGt.filter(g => {
              if (!g.coordenacao) return false;
              let cId = typeof g.coordenacao === 'object' ? g.coordenacao.idcoordenacao : g.coordenacao;
              console.log("cId", cId);
              console.log(myCoords.some(c => c.idcoordenacao === cId));
              return myCoords.some(c => c.idcoordenacao === cId);
            });
            this.listaGtFiltro = myGt;
            this.listaGtFiltroFiltrada = myGt;
            this.carregarResponsaveis(myGt);
          });
        });
      } else {
        this.$clubApi.get("/user/info").then(res => {
          let u = res.data.object;
          let myGt = [];
          if (u.grupoTrabalho) myGt.push(u.grupoTrabalho);
          if (u.grupotrabalho) {
            u.grupotrabalho.forEach(g => {
              if (!myGt.some(mg => mg.idgt === g.idgt)) myGt.push(g);
            });
          }
          this.listaGtFiltro = myGt;
          this.listaGtFiltroFiltrada = myGt;
          this.carregarResponsaveis(myGt);
        });
      }
    },
    totalPorSituacao(situacao) {
      return this.listaOkrFiltrada.filter(o => o.situacao === situacao).length;
    },
    totalKrsGeral() {
      if (!this.listaOkrFiltrada) return 0;
      let total = 0;
      for (let okr of this.listaOkrFiltrada) {
        if (okr.listaIndicador) {
          total += okr.listaIndicador.length;
        }
      }
      return total;
    },
    progressoMedioGeral() {
      if (!this.listaOkrFiltrada || this.listaOkrFiltrada.length === 0) return 0;
      let soma = 0;
      let i = 0;
      for (let okr of this.listaOkrFiltrada) {
        soma += okr.progresso || 0;
        i++;
      }
      if (i == 0) return 0;
      return this.formatarProgresso(soma / i);
    },
    totalFiltradoPorTipo(tipo) {
      return this.listaOkrFiltrada.filter(o => o.tipo === tipo).length;
    },
    getChartDataHistorico(ind) {
      if (!ind || !ind.listaHistorico || ind.listaHistorico.length === 0) return null;

      // Ordena por ID crescente (ID menor à esquerda → ID maior à direita)
      const list = [...ind.listaHistorico].sort((a, b) => a.idhistorico - b.idhistorico);

      let labels = [];
      let dataValor = [];
      let dataConfianca = [];

      let meta = Number(ind.meta) || 0;
      let baseline = Number(ind.baseline) || 0;
      let range = meta - baseline;

      for (let h of list) {
        labels.push(h.dataAtualizacao);

        let valorNum = Number(h.valor) || 0;
        let prog = 0;

        if (range !== 0) {
          prog = ((valorNum - baseline) / range) * 100;
        } else {
          prog = meta !== 0 ? (valorNum / meta) * 100 : 0;
        }
        // Valor real sem cap para o gráfico (eixo Y se ajusta; > 100% significa meta superada)
        dataValor.push(this.formatarProgressoExibicao(prog));
        dataConfianca.push(Number(h.confianca) || 0);
      }
      return {
        labels: labels,
        datasets: [{
          label: 'Progresso (%)',
          data: dataValor,
          fill: false,
          borderColor: 'rgb(23, 162, 184)',
          backgroundColor: 'rgba(23, 162, 184, 0.1)',
          pointBackgroundColor: 'rgb(23, 162, 184)',
          pointRadius: 2,
          tension: 0.4,
          steppedLine: false,
          yAxisID: 'progressao'
        }, {
          label: 'Confiança',
          data: dataConfianca,
          fill: false,
          borderColor: '#28a745',
          backgroundColor: 'rgba(40, 167, 69, 0.1)',
          pointBackgroundColor: '#28a745',
          pointRadius: 2,
          tension: 0.4,
          steppedLine: false,
          yAxisID: 'confianca'
        }]
      };
    },
    okrsPorTipoFiltrada(tipo) {
      return this.listaOkrFiltrada.filter(o => o.tipo === tipo);
    },
    isAdmin() {
      return this.perfil === 'ADMIN';
    },
    isResponsavelOkr(okr) {
      if (!okr || !okr.listaResponsavel) return false;
      return okr.listaResponsavel.some(u => Number(u.idusuario) === this.userId);
    },
    podeEditarObjetivo(okr) {
      return this.isAdmin(); // Apenas usuários ADMIN podem alterar dados do Objetivo.
    },
    podeEditar(okr) {
      if (!okr) return false;
      if (okr.situacao === 'CANCELADO') return false;
      return this.isAdmin() || this.isResponsavelOkr(okr);
    },
    podeGerenciarProjeto(okr) {
      return !!okr && okr.situacao === 'EMANDAMENTO';
    },
    isResponsavelProjeto(projeto) {
      if (!projeto || !projeto.listaResponsavel) return false;
      return projeto.listaResponsavel.some(u => Number(u.idusuario) === this.userId);
    },
    podeAdicionarAtividade(okr, projeto) {
      if (!okr || !projeto) return false;
      return this.podeEditar(okr) && this.isResponsavelProjeto(projeto);
    },
    corSituacaoBadge(situacao) {
      if (situacao === 'EMANDAMENTO') return 'badge-info';
      if (situacao === 'CONCLUIDO') return 'badge-success';
      if (situacao === 'CANCELADO') return 'badge-danger';
      return 'badge-secondary';
    },
    corSituacaoTexto(situacao) {
      if (situacao === 'EMANDAMENTO') return 'text-info font-weight-bold';
      if (situacao === 'CONCLUIDO') return 'text-success font-weight-bold';
      if (situacao === 'CANCELADO') return 'text-danger font-weight-bold';
      return 'text-secondary font-weight-bold';
    },
    corSituacaoProjetoTexto(situacao) {
      if (situacao === 'EMANDAMENTO') return 'text-info font-weight-bold';
      if (situacao === 'CONCLUIDO') return 'text-success font-weight-bold';
      if (situacao === 'CANCELADO' || situacao === 'REJEITADO' || situacao === 'ATRASADO') return 'text-danger font-weight-bold';
      return 'text-secondary font-weight-bold';
    },
    corSituacaoAtividadeTexto(situacao) {
      if (situacao === 'EMANDAMENTO') return 'text-info font-weight-bold';
      if (situacao === 'CONCLUIDA') return 'text-success font-weight-bold';
      if (situacao === 'CANCELADA' || situacao === 'REJEITADA' || situacao === 'ATRASADA') return 'text-danger font-weight-bold';
      return 'text-secondary font-weight-bold';
    },
    toggleOkr(idokr) {
      let idx = this.okrsAbertos.indexOf(idokr);
      if (idx >= 0) { this.okrsAbertos.splice(idx, 1); }
      else          { this.okrsAbertos.push(idokr); }
    },
    okrAberto(idokr) {
      return this.okrsAbertos.includes(idokr);
    },
    toggleProjeto(idokr, idprojeto) {
      const aberto = this.projetoAbertoPorOkr[idokr] === idprojeto;
      this.$set(this.projetoAbertoPorOkr, idokr, aberto ? null : idprojeto);
    },
    projetoAberto(idokr, idprojeto) {
      return this.projetoAbertoPorOkr[idokr] === idprojeto;
    },
    novoOkr() {
      location.href = '/okr-cadastro';
    },
    editarOkr(idokr) {
      location.href = '/okr-cadastro/' + idokr;
    },
    cancelarOkr(okr) {
      const options = { title: "Confirmar Cancelamento", okLabel: "Cancelar Objetivo", cancelLabel: "Voltar" };
      this.$dialogs.confirm(`Deseja cancelar o Objetivo "${okr.descricao}"? Esta ação não pode ser desfeita.`, options)
        .then((res) => {
          if (!res.ok) return;
          this.progress = true;
          this.$clubApi.post(`/okr/${okr.idokr}/cancelar`).then(() => {
            this.$toastr.success("Objetivo cancelado com sucesso!");
            this.carregarTela();
          }).catch((e) => {
            this.$toastr.error((e.response && e.response.data && e.response.data.msg) || "Erro ao cancelar Objetivo.");
            this.progress = false;
          });
        });
    },
    concluirOkr(okr) {
      const options = { title: "Confirmar Conclusão", okLabel: "Concluir Objetivo", cancelLabel: "Voltar" };
      this.$dialogs.confirm(`Deseja concluir o Objetivo "${okr.descricao}"?`, options)
        .then((res) => {
          if (!res.ok) return;
          this.progress = true;
          this.$clubApi.post(`/okr/${okr.idokr}/concluir`).then(() => {
            this.$toastr.success("Objetivo concluído com sucesso!");
            this.carregarTela();
          }).catch((e) => {
            this.$toastr.error((e.response && e.response.data && e.response.data.msg) || "Erro ao concluir Objetivo.");
            this.progress = false;
          });
        });
    },
    abrirModalAtualizar(idokr, ind) {
      this.indicadorAtualizar = {
        idokr:       idokr,
        idindicador: ind.idindicador,
        descricao:   ind.descricao,
        atual:       ind.atual,
        meta:        ind.meta,
        confianca:   ind.confianca || 5,
        observacao:  "",
        baseline:    ind.baseline,
        tipoIndicador: ind.tipoIndicador,
        sentido:     ind.sentido,
        fonte:       ind.fonte,
        formaCalculo: ind.formaCalculo || "",
        situacao:    ind.situacao,
        situacaoDescricao: ind.situacaoDescricao
      };
      this.modals.modalAtualizar = true;
    },
    abrirModalNovoIndicador(okr) {
      this.okrNovoIndicador = { idokr: okr.idokr, descricao: okr.descricao };
      this.indicadorNovo = { descricao: "", baseline: null, meta: null, tipoIndicador: "", sentido: "", fonte: "", formaCalculo: "", situacao: "NAO_INICIADO" };
      this.modals.modalNovoIndicador = true;
      this.$nextTick(() => {
        if (this.$refs.novoIndDescricaoInput) this.$refs.novoIndDescricaoInput.focus();
      });
    },
    fecharModalNovoIndicador() {
      this.modals.modalNovoIndicador = false;
    },
    confirmarNovoIndicador() {
      if (!this.indicadorNovo.descricao) { this.$toastr.error("Título do indicador é obrigatória!"); return; }
      if (this.indicadorNovo.baseline === null || this.indicadorNovo.baseline === undefined || this.indicadorNovo.baseline === '') { this.$toastr.error("Baseline do indicador é obrigatória!"); return; }
      if (this.indicadorNovo.meta === null || this.indicadorNovo.meta === undefined || this.indicadorNovo.meta === '') { this.$toastr.error("Meta do indicador é obrigatória!"); return; }
      if (!this.indicadorNovo.tipoIndicador) { this.$toastr.error("Tipo do indicador é obrigatório!"); return; }
      if (!this.indicadorNovo.sentido) { this.$toastr.error("Sentido do indicador é obrigatório!"); return; }
      if ((this.indicadorNovo.formaCalculo || '').length > 4000) { this.$toastr.error("Forma de Cálculo deve ter no máximo 4000 caracteres."); return; }

      const baselineVal = parseFloat(this.indicadorNovo.baseline) || 0;
      const metaVal = parseFloat(this.indicadorNovo.meta);
      if (metaVal === baselineVal) {
        this.$toastr.error("O valor da Meta deve ser diferente do valor da Baseline!");
        return;
      }

      const okr = this.listaOkr.find(o => o.idokr === this.okrNovoIndicador.idokr);
      if (!okr) {
        this.$toastr.error("Objetivo não encontrado para incluir indicador.");
        return;
      }

      this.modals.modalNovoIndicador = false;
      this.progress = true;

      const payload = {
        idokr: okr.idokr,
        descricao: okr.descricao,
        dataFim: okr.dataFim,
        tipo: okr.tipo,
        situacao: okr.situacao,
        idgt: okr.grupoTrabalho ? okr.grupoTrabalho.idgt : null,
        listaResp: (okr.listaResponsavel || []).map(r => ({ idusuario: r.idusuario })),
        listaIdProjeto: (okr.listaProjeto || []).map(p => p.idprojeto),
        listaIndicador: [{
          descricao: this.indicadorNovo.descricao,
          baseline: this.indicadorNovo.baseline,
          meta: this.indicadorNovo.meta,
          tipoIndicador: this.indicadorNovo.tipoIndicador,
          sentido: this.indicadorNovo.sentido,
          fonte: this.indicadorNovo.fonte,
          formaCalculo: this.indicadorNovo.formaCalculo,
          situacao: this.indicadorNovo.situacao || 'NAO_INICIADO',
        }],
      };

      this.$clubApi.put(`/okr/${okr.idokr}`, payload)
        .then(() => {
          this.$toastr.success("Indicador incluído com sucesso!");
          this.carregarTela();
        })
        .catch((e) => {
          const msg = e.response && e.response.data && e.response.data.msg;
          this.$toastr.error(msg || "Erro ao incluir indicador.");
          this.modals.modalNovoIndicador = true;
          this.progress = false;
        });
    },
    confirmarAtualizar() {
      if (this.indicadorAtualizar.atual === null || this.indicadorAtualizar.atual === "") {
        this.$toastr.error("Informe o Valor Atual!"); return;
      }
      if ((this.indicadorAtualizar.formaCalculo || '').length > 4000) { this.$toastr.error("Forma de Cálculo deve ter no máximo 4000 caracteres."); return; }

      // Fecha a modal temporariamente para que o diálogo de confirmação não fique atrás
      this.modals.modalAtualizar = false;

      const options = { title: "Confirmar Atualização", okLabel: "Atualizar", cancelLabel: "Voltar" };
      this.$dialogs.confirm("Deseja atualizar os dados do indicador?", options)
        .then((res) => {
          if (!res.ok) {
            // Se o usuário clicar em "Voltar", reabre a modal com os dados preservados
            this.modals.modalAtualizar = true;
            return;
          }
          this.progress = true;
          let payload = {
            idindicador:  this.indicadorAtualizar.idindicador,
            atual:        this.indicadorAtualizar.atual,
            confianca:    this.indicadorAtualizar.confianca,
            observacao:   this.indicadorAtualizar.observacao,
            baseline:     this.indicadorAtualizar.baseline,
            meta:         this.indicadorAtualizar.meta,
            tipoIndicador: this.indicadorAtualizar.tipoIndicador,
            sentido:      this.indicadorAtualizar.sentido,
            fonte:        this.indicadorAtualizar.fonte,
            formaCalculo: this.indicadorAtualizar.formaCalculo
          };

          this.$clubApi.post(`/okr/${this.indicadorAtualizar.idokr}/indicador`, payload).then(() => {
            this.$toastr.success("Indicador atualizado com sucesso!");
            this.carregarTela();
          }).catch((e) => {
            this.$toastr.error((e.response && e.response.data && e.response.data.msg) || "Erro ao atualizar indicador.");
            this.modals.modalAtualizar = true;
            this.progress = false;
          });
        });
    },
    corConfianca(val) {
      if (!val) return "text-muted";
      if (val <= 3) return "text-danger";
      if (val <= 7) return "text-warning";
      return "text-success";
    },
    corBarraConfianca(valor) {
      if (!valor) return "cor-confianca-neutra";
      if (valor <= 3) return "cor-confianca-baixa";
      if (valor <= 7) return "cor-confianca-media";
      return "cor-confianca-alta";
    },
    corBarraProgresso(val) {
      if (!val || val < 30) return "bg-danger";
      if (val <= 70)         return "bg-warning";
      return "bg-success";
    },
    addMascaraCodigo(tipo, valor) {
      return `${tipo}-${String(valor).padStart(3, '0')}`;
    },
    ordenarHistoricoRecentePrimeiro(lista) {
      if (!Array.isArray(lista)) return [];
      return [...lista].sort((a, b) => b.idhistorico - a.idhistorico);
    },
    okrMatchBusca(okr, busca) {
      if (!okr || !busca) return false;
      const emTexto = (valor) => (valor === null || valor === undefined ? '' : String(valor).toUpperCase());
      const contem = (valor) => emTexto(valor).indexOf(busca) >= 0;

      if (contem(okr.descricao) || contem(okr.idokr) || contem(this.addMascaraCodigo('OKR', okr.idokr))) {
        return true;
      }

      if (okr.listaIndicador && okr.listaIndicador.some((ind, idx) => contem(ind.descricao) || contem(this.mascaraKr(okr, idx)))) {
        return true;
      }

      if (okr.listaProjeto && okr.listaProjeto.some(proj => {
        if (contem(proj.codigoNome) || contem(proj.codigo) || contem(proj.titulo) || contem(proj.descricao)) {
          return true;
        }
        if (proj.listaAtividade && proj.listaAtividade.some(ativ => contem(ativ.codigoNome) || contem(ativ.codigo) || contem(ativ.nome) || contem(ativ.titulo) || contem(ativ.descricao))) {
          return true;
        }
        return false;
      })) {
        return true;
      }

      return false;
    },
    resumirObservacao(obs) {
      if (!obs) return '--';
      return obs.length > 20 ? obs.substring(0, 20) + '...' : obs;
    },
    formatarProgresso(val) {
      // Uso: largura de barras de progresso (limitado a 100%)
      if (!val) return 0;
      let p = Math.round(val);
      if (p > 100) return 100;
      if (p < 0) return 0;
      return p;
    },
    formatarProgressoExibicao(val) {
      // Uso: exibição de número (sem limite em 100% — mostra progresso real)
      if (!val && val !== 0) return 0;
      let p = Math.round(val);
      if (p < 0) return 0;
      return p;
    },
    mascaraKr(okr, idx) {
      // Formato: KR-OKR.SEQ — ex: KR-004.01
      const okrPad = String(okr.idokr).padStart(3, '0');
      const krPad = String((idx || 0) + 1).padStart(2, '0');
      return `KR-${okrPad}.${krPad}`;
    },
    okrCancelado(situacao) {
      if (situacao === 'CANCELADO') return 'text-decoration: line-through; color: #979797';
      return '';
    },
	totalizarAtividades(listaProjetos) {
		let total = 0;
    (listaProjetos || []).forEach(projeto => {
      total += (projeto.listaAtividade || []).length;
		});
		return total;
	},
  totalKrsPorSituacao(okr, situacao) {
    if (!okr || !okr.listaIndicador) return 0;
    return okr.listaIndicador.filter(ind => ind && ind.situacao === situacao).length;
  },
  totalInvestimentoOkr(listaProjetos) {
    let total = 0;
    (listaProjetos || []).forEach(projeto => {
      (projeto.listaAtividade || []).forEach(atividade => {
        const valor = Number(atividade && atividade.investimento);
        if (!Number.isNaN(valor)) total += valor;
      });
    });
    return total;
  },
  formatarMoeda(valor) {
    const numero = Number(valor) || 0;
    return numero.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  },

    // ---- VINCULAR PROJETO AO OKR (monitoramento) ----
    abrirModalVincularProjeto(okr) {
      this.okrVincularProjeto = { idokr: okr.idokr, descricao: okr.descricao };
      this.addProjNome = '';
      this.listaAddProjVincular = [];
      this.modals.modalVincularProjeto = true;
      this.$nextTick(() => {
        if (this.$refs.addProjNomeInput) this.$refs.addProjNomeInput.focus();
      });
    },
    pesquisarProjetoVincular() {
      if (this.timeoutProj) clearTimeout(this.timeoutProj);
      if (!this.addProjNome || this.addProjNome.length < 3) {
        this.listaAddProjVincular = [];
        return;
      }
      this.listaAddProjVincular = [];
      this.timeoutProj = setTimeout(() => {
        this.progressVincularProjeto = true;
        this.$clubApi.post('/projeto/lista', { nome: this.addProjNome }).then((r) => {
          this.listaAddProjVincular = r.data.object || [];
        }).catch(() => {
          this.$toastr.error('Erro ao pesquisar projetos.');
        }).finally(() => { this.progressVincularProjeto = false; });
      }, 500);
    },
    confirmarVincularProjeto(proj) {
      // Validação local: projeto já vinculado
      let okr = this.listaOkr.find(o => o.idokr === this.okrVincularProjeto.idokr);
      if (okr && okr.listaProjeto && okr.listaProjeto.some(p => p.idprojeto === proj.idprojeto)) {
        this.$toastr.error('Projeto já vinculado a esse objetivo');
        return;
      }
      // Fecha a modal antes do loading para que o spinner fique visível na tela toda
      this.fecharModalVincularProjeto();
      this.progress = true;
      this.$clubApi.post(`/okr/${this.okrVincularProjeto.idokr}/projeto`, { idprojeto: proj.idprojeto })
        .then(() => {
          this.$toastr.success('Projeto vinculado com sucesso');
          this.addProjNome = '';
          this.listaAddProjVincular = [];
          this.carregarTela(); // carregarTela() controla o progress até o fim
        }).catch((e) => {
          const msg = e.response && e.response.data && e.response.data.msg;
          this.$toastr.error(msg || 'Projeto já vinculado a esse objetivo');
          this.progress = false; // só zera aqui no erro, pois não vai chamar carregarTela
        });
    },
    fecharModalVincularProjeto() {
      this.addProjNome = '';
      this.listaAddProjVincular = [];
      this.modals.modalVincularProjeto = false;
    },

    // ---- PROJETOS NÃO VINCULADOS ----
    carregarProjetosNaoVinculados() {
      this.progressProjetosNaoVinculados = true;
      this.$clubApi.get('/okr/projetos-nao-vinculados')
        .then(r => {
          this.listaProjetosNaoVinculados = r.data.object || [];
        })
        .catch(() => {
          this.$toastr.error('Erro ao carregar projetos não vinculados.');
          this.listaProjetosNaoVinculados = [];
        })
        .finally(() => { this.progressProjetosNaoVinculados = false; });
    },
    abrirModalVincularAoOkr(proj) {
      this.projetoVincularAoOkr = proj;
      this.filtroOkrVinculo = '';
      this.modals.modalVincularAoOkr = true;
    },
    fecharModalVincularAoOkr() {
      this.projetoVincularAoOkr = null;
      this.filtroOkrVinculo = '';
      this.modals.modalVincularAoOkr = false;
    },
    confirmarVincularProjetoAoOkr(okr) {
      if (!this.projetoVincularAoOkr) return;
      const idprojeto = this.projetoVincularAoOkr.idprojeto;
      this.fecharModalVincularAoOkr();
      this.progress = true;
      this.$clubApi.post(`/okr/${okr.idokr}/projeto`, { idprojeto })
        .then(() => {
          this.$toastr.success('Projeto vinculado ao OKR com sucesso!');
          // Remove o projeto da lista local sem precisar recarregar tudo
          this.listaProjetosNaoVinculados = this.listaProjetosNaoVinculados.filter(p => p.idprojeto !== idprojeto);
          this.carregarTela();
        })
        .catch(e => {
          const msg = e.response && e.response.data && e.response.data.msg;
          this.$toastr.error(msg || 'Erro ao vincular projeto ao OKR.');
          this.progress = false;
        });
    },

    // ---- SITUAÇÃO DO KR ----
    podeMoverKr(ind) {
      // Retorna true se o KR ainda pode ser movimentado (não está concluído nem cancelado)
      return ind.situacao !== 'ALCANCADO' && ind.situacao !== 'CANCELADO';
    },
    corSituacaoKrTexto(situacao) {
      if (situacao === 'EM_ANDAMENTO') return 'text-primary';
      if (situacao === 'ALCANCADO')   return 'text-success';
      if (situacao === 'CANCELADO')   return 'text-danger';
      return 'text-muted'; // NAO_INICIADO
    },
    alterarSituacaoKr(idokr, ind, novaSituacao) {
      const labels = {
        EM_ANDAMENTO: { title: 'Confirmar Início',          ok: 'Iniciar KR',    msg: `Deseja iniciar o KR "${ind.descricao}"?` },
        REVERTER:     { title: 'Confirmar Reversão',        ok: 'Sim',           msg: `Deseja realmente alterar a situação desse Indicador para 'Em andamento'?` },
        ALCANCADO:    { title: 'Confirmar Conclusão',       ok: 'Concluir KR',   msg: `Deseja marcar o KR "${ind.descricao}" como Alcançado?` },
        CANCELADO:    { title: 'Confirmar Cancelamento',    ok: 'Cancelar KR',   msg: `Deseja cancelar o KR "${ind.descricao}"? Esta ação não pode ser desfeita.` },
      };
      const cfg = labels[novaSituacao];
      if (!cfg) return;
      const apiSituacao = novaSituacao === 'REVERTER' ? 'EM_ANDAMENTO' : novaSituacao;
      const options = { title: cfg.title, okLabel: cfg.ok, cancelLabel: 'Voltar' };
      this.$dialogs.confirm(cfg.msg, options).then((res) => {
        if (!res.ok) return;
        this.progress = true;
        this.$clubApi.patch(`/okr/${idokr}/indicador/${ind.idindicador}/situacao`,
          { situacao: apiSituacao })
          .then(() => {
            const msgs = { EM_ANDAMENTO: 'KR iniciado!', REVERTER: 'KR voltado para Em andamento!', ALCANCADO: 'KR concluído!', CANCELADO: 'KR cancelado!' };
            this.$toastr.success(msgs[novaSituacao] || 'Situação atualizada!');
            this.carregarTela();
          }).catch((e) => {
            const msg = e.response && e.response.data && e.response.data.msg;
            this.$toastr.error(msg || 'Erro ao alterar situação do KR.');
            this.progress = false; // só encerra aqui se der erro. Se der sucesso, carregarTela() controla até o fim.
          });
      });
    },
    // ---- FONTE DE VERIFICAÇÃO ----
    tipoIndicadorBadge(tipo) {
      const map = { PERCENTUAL: '%', ABSOLUTO: 'N', INDICE: 'Í', TAXA: 'T', RAZAO: 'R' };
      return map[tipo] || tipo;
    },
    abrirModalFonte(ind) {
      this.indicadorFonte = { descricao: ind.descricao, fonte: ind.fonte };
      this.modals.modalFonte = true;
    },
    corPrazoAtualizacao(dias) {
      if (dias === null || dias === undefined) return '';
      if (dias < 0) return 'text-danger';
      if (dias <= 5) return 'texto-prazo-atualizacao';
      return '';
    },
    tooltipPrazoAtualizacao(dias) {
      if (dias === null || dias === undefined) return '';
      if (dias < 0) {
        const d = Math.abs(dias);
        return 'Atualização em atraso (' + d + (d === 1 ? ' dia' : ' dias') + ')';
      }
      if (dias == 0) return 'Último dia para atualização';
      if (dias <= 5) return 'Atualizar em ' + dias + (dias === 1 ? ' dia' : ' dias');
      return 'Próxima atualização em ' + dias + ' dias';
    },

    // ---- CRIAR PROJETO E VINCULAR AO OKR ----
    abrirModalCriarProjeto(okr) {
      this.okrParaCriarProjeto = okr;
      this.modals.modalCriarProjeto = true;
    },
    fecharModalCriarProjeto() {
      this.modals.modalCriarProjeto = false;
      this.okrParaCriarProjeto = null;
    },
    projetoCriado(projeto) {
      if (!projeto || !projeto.idprojeto) {
        this.fecharModalCriarProjeto();
        this.carregarTela();
        return;
      }
      const idokr = this.okrParaCriarProjeto.idokr;
      this.fecharModalCriarProjeto();
      this.progress = true;
      this.$clubApi.post(`/okr/${idokr}/projeto`, { idprojeto: projeto.idprojeto })
        .then(() => {
          this.$toastr.success("Projeto criado e vinculado ao Objetivo!");
          this.carregarTela();
        })
        .catch((e) => {
          this.$toastr.error(e.response && e.response.data ? e.response.data.msg : "Erro ao vincular projeto ao Objetivo.");
          this.progress = false;
        });
    },

    abrirModalCriarAtividade(okr, projeto) {
      this.okrParaCriarProjeto = okr;
      this.projetoParaCriarAtividade = projeto;
      this.modals.modalCriarAtividade = true;
    },
    fecharModalCriarAtividade() {
      this.modals.modalCriarAtividade = false;
      this.projetoParaCriarAtividade = null;
    },
    atividadeCriada() {
      this.fecharModalCriarAtividade();
      this.carregarTela();
    },

    // ---- DESVINCULAR PROJETO DO OKR (monitoramento) ----
    desvincularprojeto(okr, proj) {
      const options = { title: "Confirmar Desvinculação", okLabel: "Desvincular", cancelLabel: "Cancelar" };
      this.$dialogs.confirm('Deseja retirar o projeto do vínculo com essa OKR?', options)
        .then((res) => {
          if (!res.ok) return;
          this.progress = true;
          this.$clubApi.delete(`/okr/${okr.idokr}/projeto/${proj.idprojeto}`)
            .then(() => {
              this.$toastr.success('Projeto desvinculado com sucesso!');
              this.carregarTela(); // carregarTela() controla o progress até o fim
            }).catch((e) => {
              const msg = e.response && e.response.data && e.response.data.msg;
              this.$toastr.error(msg || 'Erro ao desvincular projeto.');
              this.progress = false; // só zera aqui no erro, pois não vai chamar carregarTela
            });
        });
    },

    // ---- VISUALIZAR PROJETO ----
    abrirModalVisualizarProjeto(projeto) {
      if (!projeto || !projeto.idprojeto) return;
      const idProjeto = projeto.idprojeto;
      this.projetoParaVisualizar = projeto;
      this.carregandoProjetoVisualizacao = true;
      this.modals.modalVisualizarProjeto = true;

      if (this.cacheProjetoDetalhe[idProjeto]) {
        this.projetoParaVisualizar = this.cacheProjetoDetalhe[idProjeto];
        this.carregandoProjetoVisualizacao = false;
        return;
      }

      this.$clubApi.get(`/atividade/projeto/${idProjeto}`).then((response) => {
        const detalheProjeto = response.data.object || projeto;
        this.projetoParaVisualizar = detalheProjeto;
        this.$set(this.cacheProjetoDetalhe, idProjeto, detalheProjeto);
      }).catch((e) => {
        this.projetoParaVisualizar = projeto;
        this.modals.modalVisualizarProjeto = true;
        const msg = e.response && e.response.data && e.response.data.msg;
        this.$toastr.error(msg || 'Erro ao carregar projeto.');
      }).finally(() => {
        this.carregandoProjetoVisualizacao = false;
      });
    },
    fecharModalVisualizarProjeto() {
      this.modals.modalVisualizarProjeto = false;
      this.carregandoProjetoVisualizacao = false;
      this.projetoParaVisualizar = null;
    },

    // ---- VISUALIZAR ATIVIDADE ----
    abrirModalVisualizarAtividade(atividade) {
      this.atividadeParaVisualizar = atividade;
      this.modals.modalVisualizarAtividade = true;
    },
    fecharModalVisualizarAtividade() {
      this.modals.modalVisualizarAtividade = false;
      this.atividadeParaVisualizar = null;
    },

    // ---- EXCLUIR HISTÓRICO DE INDICADOR ----
    excluirHistoricoIndicador(idokr, idindicador, idhistorico) {
      const options = { title: "Confirmar Exclusão", okLabel: "Sim, excluir", cancelLabel: "Cancelar" };
      this.$dialogs.confirm("Deseja excluir este registro de histórico? Esta ação não pode ser desfeita.", options)
        .then((res) => {
          if (!res.ok) return;
          this.progress = true;
          this.$clubApi.delete(`/okr/${idokr}/indicador/${idindicador}/historico/${idhistorico}`)
            .then(() => {
              this.$toastr.success('Histórico excluído com sucesso!');
              this.carregarTela();
            })
            .catch((error) => {
              const msg = error.response.data.message || 'Erro ao excluir histórico.';
              this.$toastr.error(msg);
              this.progress = false;
            });
        });
    },
  },
};
</script>

<style scoped>
.container-fluid { padding-left: 10px !important; padding-right: 10px !important; }
.total-card      { border-radius: 8px; line-height: 1.2; }
.total-num       { font-size: 1.5rem; font-weight: bold; }
.total-num-data  { font-size: 18px; font-weight: bold; margin-top: 8px; }
.total-num-porc  { font-size: 15px; font-weight: bold; }
.total-label     { font-size: 0.75rem; color: #666666; margin-top: 2px; }
.total-total     { border-left: 4px solid #979797; }
.total-total-kr  { border-left: 4px solid #d4d4d6; }
.total-progresso { border-left: 4px solid #b88d17; }
.total-andamento { border-left: 4px solid #17a2b8; }
.total-concluido { border-left: 4px solid #28a745; }
.total-cancelado { border-left: 4px solid #dc3545; }
.total-total-kr-nao-iniciado { border-left: 4px solid #6c757d; }
.total-investimento-okr { border-left: 4px solid #495057; background-color: #f8f9fa; }

.total-meta { border-left: 4px solid #28a745; background-color: #f3fff6; }

.cor-confianca-neutra { background-color: #ccc }
.cor-confianca-baixa  { background-color: #dc3545 }
.cor-confianca-media  { background-color: #ffc107 }
.cor-confianca-alta   { background-color: #28a745 }

.secao-header  { background-color: #f8f9fa; font-size: 15px; }
.filtros-header{ background-color: #f0f4ff; font-size: 15px; }

.okr-item:last-child { border-bottom: none !important; }
.okr-header          { font-size: 14px; }
.okr-header:hover    { background-color: #f8f9fa; }
.okr-header-aberto:hover {
  background-color: #e1cfe9;
}
.okr-header-aberto {
  background-color: #edddf4;
  border: 1px solid #ca9bf7;
  border-radius: 6px;
  transform: scale(1.01);
  transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  z-index: 1;
  position: relative;
}
.okr-detalhe         { background-color: #fafbff; border-top: 1px solid #e9ecef; }
.okr-item-aberto     { border-left: 2px solid #ca9bf7; }
.projeto-item-aberto { border-left: 3px solid #6ac06a !important; }
.projeto-nao-v-item-aberto { border-left: 3px solid #d8b362 !important; }
.projeto-header          { font-size: 14px; }
.projeto-header:hover    { background-color: #fff; }

.texto-prazo-atualizacao { color: #b88d17 }

.indicador-card {
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  border-left: 4px solid #007bff;
}

.indicator-toggle .fa-chevron-down {
  transition: transform 0.3s ease;
}
.indicator-toggle:not(.collapsed) .fa-chevron-down {
  transform: rotate(180deg);
}

.readonly-field,
.readonly-field:disabled,
.readonly-field[readonly] {
  background-color: #e9ecef !important;
  color: #6c757d !important;
  cursor: not-allowed;
}

.fab-button {
  position: relative;
  top: 0;
  right: 0;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  margin: -62px 30px 8px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  transition: all 0.3s ease;
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  border: none;
  color: white;
}
.fab-button:hover {
  transform: scale(1.1) rotate(90deg);
  box-shadow: 0 10px 20px rgba(0,0,0,0.3) !important;
}

/* Estilos lista de pesquisa de projetos */
.opcao { color: #c0c0c0; cursor: pointer; }
.opcao:hover { color: red; cursor: pointer; }
.listaGT { align-items: flex-start; display: flex; margin-bottom: 4px; padding: 6px 4px; min-height: 40px; height: auto; }
.listaGT:hover { background-color: #edebfe; cursor: pointer; }
.listaGT:hover .opcao { visibility: visible; opacity: 1; }
.gtInfo { display: flex; width: 100%; justify-content: space-between; align-items: center; }
</style>
